/* eslint-disable no-extra-boolean-cast */
/* eslint-disable no-unused-vars */
/* eslint-disable space-unary-ops */
/* eslint-disable no-undef */
/* eslint-disable no-useless-return */
import * as shipmentService from '@/api/biz/shipment/shipmentService';
import * as checkConstant from '@/api/biz/outbound/checkConstant';
import * as payTypeConstant from '@/api/biz/shipment/pack/payTypeConstant';
import {print, convertBase64, collectLabelInfo} from '@/api/print/print.js';
import printjs from '@/api/lib/print.min.js'
import * as printConst from '../../../../api/print/constant.js';
import { i18n } from '@/api/i18n';
import * as paperlessPackageTagHelper from '@/api/biz/shipment/pack/paperlessPackageTagHelper';
import { formatDateTime } from '@/api/utils/date'
import * as barcode from '@/api/print/barcode';
import _ from 'lodash'
import { $notify, userInfo } from '@/global'
import { asyncLabel } from '../../../../api/biz/outbound/OutBoundService.js'

import CryptoJS from 'crypto-js'
import {restUrls} from '@/api/rest/url';
import * as sparkMD5 from 'spark-md5';
import axios from 'axios';
import store from '@/store/store.js';
import { printStart,printEnd,printPointEnd,changeANode } from '@/utils/setMethods.js';
import Cookies from 'js-cookie'
import SgmMonitor from '@/api/lib/monitor'
import { scReport } from '@/api/lib/report'
import getPrefix from '@/api/apiConfig.js'

// import Print  from 'vue-print-nb';
// import Vue from 'vue'
import {
  queryDeliveryOrderInfo,
  batchQueryDeliveryOrderInfo,
  queryWaybillOrderInfo,
  queryOutboundOrderInfo,
  getPackageMDByBatchNo,
  queryCatalogListByGoodsNo,
  queryPackageDByOutboundNo,
  modifyPackageNo,
  queryPackageMByOutboundNo,
  getLabelsForSelfCloudPrint,
  getPrintAdrFileInfo
} from '@/api/biz/shipment/shipmentService'
import {getSysConfigByKey, getWarehouse} from '@/api/biz/master/masterService.js'
import { addLog, getSystemConfig } from '@/api/biz/master/masterService'
import requestTry from '@/api/rest/requestTry';
import { getOrderInvoiceInfoGlobalization,callPrintPlatform,qryDicDetailByCode } from '@/api/biz/shipment/pack/pack'
import { customizeNotifyWithVoice, NOTIFY_TYPE_ENUM } from '@/api/utils/message.js'
import { cloudPrintFaceLabelType,LabelType, shipmentLabelType, labelKindFor3pl, waybillTypeMapping, BUSINESS_TAG } from "../../bizEnum";
import {getOrgWarehouseName} from "../shipmentService";
import {printZPL} from '@/api/print/printZpl'
import {SgmPrintMonitor} from '@/api/lib/monitor/printMonitor'
import { getOrderFace } from '@/utils/indexedDB/storageOrderFaceData.js';
import { initOrderActions } from "@/api/biz/shipment/pack/resolveWMSOrderAction.js";
import * as FeAddlog from "../../../lib/addLog.js";
// Vue.use(Print);

/**
* 获取商品大类-目前只有KK客户单需要
*/
const getCatalogListByGoodsNo=async (goodsNoArr) =>{
  if(!goodsNoArr|| !goodsNoArr.length) return ''
  let classificationArr=[];
  let res='';
  for(let i=0; i<goodsNoArr.length; i++){
    let queryFromMaster = {
      orgNo: userInfo.orgNo,
      distributeNo: userInfo.distributeNo,
      warehouseNo: userInfo.warehouseNo,
      goodsNo:goodsNoArr[i]
    };
    try {
      let classification = await queryCatalogListByGoodsNo(queryFromMaster)
      if(classification && classification[0] && (classification[0].typeName)){
        classificationArr.push(classification[0].typeName)
      }
    } catch (error) {
      console.log('queryCatalogListByGoodsNo 失败',error)
    }
  }
  // console.log('classificationArr>>>>>',classificationArr);
  const classifications=[...new Set(classificationArr)].splice(0,5)
  classifications.forEach((item,index)=>{
    res += index == classifications.length-1 ? `${index+1}.${item}` : `${index+1}.${item}\n `
  })
   // console.log('KK面单类目==========',res)
  return res
}
   //获取包裹数据
const getCommonPackageDetail=async(outboundNo)=>{
  let obCheckQuery = {
    orgNo: userInfo.orgNo,
    distributeNo: userInfo.distributeNo,
    warehouseNo: userInfo.warehouseNo,
    outboundNo,
  };
  const obCheckMList = await queryPackageDByOutboundNo(obCheckQuery);
 // console.log('obCheckMList>>>>>>>',obCheckMList)
  return obCheckMList
}
const getPackageMList=async(outboundNo)=>{
  let obCheckQuery = {
    orgNo: userInfo.orgNo,
    distributeNo: userInfo.distributeNo,
    warehouseNo: userInfo.warehouseNo,
    outboundNo,
  };
  const packageMList = await queryPackageMByOutboundNo(obCheckQuery);
  return packageMList
}

// 组装英国起网云打印参数
const buildCloudPrintParam = (data, weight = 0, listLabel, obCheckM) => {
  console.log('buildCloudPrintParam', data, weight, listLabel, obCheckM)
  const labelInfo = JSON.parse(data) || [];
  const labelData = labelInfo.length ? labelInfo[0] : {};
  const printData = labelData.printData || {};

  const {specialMarks = [], specialOperationIcon = [], addedServicesList = []} = printData;
  let content = {
    templateId: 69,
    data: {
      ...printData,
      weight: _.round(weight, 2),
      specialMarks: specialMarks.join(';'),
      specialOperationIcon: specialOperationIcon.join(';'),
      addedServicesList: addedServicesList.join(';'),
    }
  };
  if(obCheckM.selfDeliveryFlag && obCheckM.multiPackageCallSheetFlag !== 1) {
     if(listLabel?.[0]?.packageOrder > 1) {
      content.data.waybillCode = listLabel[0]?.checkShipNo
    }
    if(obCheckM.splitByPackage) {
      content.data.packageIndex = printData.packageIndex
    } else {
      content.data.packageCount = ""
      content.data.packageIndex = listLabel[0]?.packageOrder
    }
  }
  console.log('1plcontent', content)
  return content;
}

// 包裹补打场景
const buildCloudRepairPrintParam = (data, weight = 0, listLabel, obCheckM) => {
  console.log('buildCloudPrintParam', data, weight, listLabel, obCheckM)
  const labelInfo = JSON.parse(data) || [];
  const labelData = labelInfo.length ? labelInfo[0] : {};
  const printData = labelData.printData || {};
  const packageNo = listLabel[0]?.packageNo || '';
  const packageM = obCheckM.obPackageMList.find(item => item.packageNo === packageNo);

  const {specialMarks = [], specialOperationIcon = [], addedServicesList = []} = printData;
  let content = {
    templateId: 69,
    data: {
      ...printData,
      waybillCode: packageM.shipNo,
      packageIndex: packageM.packageOrder,
      packageCount: obCheckM.obPackageMList.length,
      weight: _.round(weight, 2),
      specialMarks: specialMarks.join(';'),
      specialOperationIcon: specialOperationIcon.join(';'),
      addedServicesList: addedServicesList.join(';'),
    }
  };
  
  console.log('1plcontentrepair', content)
  return content;
}

// 多包裹场景下组装起网云打印参数
const buildCloudPrintParamForMultiPack = (labelContent, pkgNum, listLabel, totalWeight) => {
  const labelInfo = JSON.parse(labelContent) || [];
  const labelData = labelInfo.length ? labelInfo[0] : {};
  const printData = labelData.printData || {};
  const {specialMarks = [], specialOperationIcon = [], addedServicesList = []} = printData;
  let packageWeight = null;
  const contentList = [];
  for (let i = 0; i < pkgNum; i++) {
    if (listLabel[i].packageWeight) {
      packageWeight = _.round(listLabel[i].packageWeight, 2)
    } else {
      packageWeight = totalWeight > 0 && (totalWeight / pkgNum).toFixed(2)
    }
    const content = {
      templateId: 69,
      data: {
        ...printData,
        packageIndex: i + 1,
        packageCount: pkgNum,
        waybillCode: listLabel[i].jdwWaybillCode,
        weight: packageWeight,
        specialMarks: specialMarks.join(';'),
        specialOperationIcon: specialOperationIcon.join(';'),
        addedServicesList: addedServicesList.join(';'),
        waybillCodeLast: (listLabel[i].jdwWaybillCode && listLabel[i].jdwWaybillCode.slice(-4)) || ''
      }
    };
    contentList.push(content);
  };
  return contentList;
}

const buildCloudPrintParamForRepairPrint = (labelContent, obPackageMList, totalWeight) => {
  const labelInfo = JSON.parse(labelContent) || [];
  const labelData = labelInfo.length ? labelInfo[0] : {};
  const printData = labelData.printData || {};
  const {specialMarks = [], specialOperationIcon = [], addedServicesList = []} = printData;
  let weight = null;
  const contentList = [];
  for (let packageM of obPackageMList) {
    const {packageOrder, packageQty, shipNo, packageWeight} = packageM;
    if (packageWeight) {
      weight = _.round(packageWeight, 2)
    } else {
      weight = totalWeight > 0 && (totalWeight / obPackageMList.length).toFixed(2)
    }
    const content = {
      templateId: 69,
      data: {
        ...printData,
        packageIndex: packageOrder,
        packageCount: packageQty,
        waybillCode: shipNo,
        weight,
        specialMarks: specialMarks.join(';'),
        specialOperationIcon: specialOperationIcon.join(';'),
        addedServicesList: addedServicesList.join(';'),
        waybillCodeLast: (shipNo && shipNo.slice(-4)) || ''
      }
    }
    contentList.push(content);
  }
  return contentList;
}

const buildShate1plPrintParams = (labelContent, listLabel, obCheckM, totalWeight) => {
  if (!listLabel?.length) {
    return;
  }
  const labelInfo = JSON.parse(labelContent) || [];
  const labelData = labelInfo?.[0] || {};
  const printData = labelData.printData || {};
  const contentList = [];
  let weight, pkgWeight, packageIndex, packageCount, waybillCode, waybillCodeLast;
  for (let i = 0; i < listLabel.length; i++) {
    // 补打场景
    if (obCheckM.isRepairPrint === 1) {
      const {packageOrder, packageQty, shipNo, packageWeight} = obCheckM.obPackageMList?.[i] || {};
      pkgWeight = packageWeight;
      packageIndex = packageOrder;
      packageCount = packageQty;
      waybillCode = shipNo;
      waybillCodeLast= shipNo?.slice(-4) || '';
    } else {
      pkgWeight = listLabel[i].packageWeight;
      packageIndex = i + 1;
      packageCount = listLabel.length;
      waybillCode = listLabel[i].jdwWaybillCode;
      waybillCodeLast= listLabel[i].jdwWaybillCode?.slice(-4) || '';
    }
    if (pkgWeight) {
      weight = _.round(pkgWeight, 2);
    } else {
      weight = totalWeight > 0 && (totalWeight / listLabel.length).toFixed(2);
    }
    let content = {
      ...printData,
      weight,
      outboundNo: listLabel[i].outboundNo,
      packageNo: listLabel[i].packageNo,
      selfTempNo: obCheckM.selfTempNo
    };
    if (listLabel.length > 1) {
      content = {
        ...content,
        packageIndex,
        packageCount,
        waybillCode,
        waybillCodeLast
      };
    }

    if(obCheckM.selfDeliveryFlag && obCheckM.multiPackageCallSheetFlag !== 1 && listLabel.length === 1) {
      content.packageCount = "";
      content.packageIndex = listLabel[0]?.packageOrder
      if(listLabel[0]?.packageOrder > 1) {
        content.waybillCode = listLabel[0]?.checkShipNo
      }
    }
    contentList.push(content);
  }
  return contentList;
}

const showUnCodeLabelDialog = (listPackagingD) => {
  if (window.APP_ENV === "GG") {
    return
  }
  const unCodeArr1 = ['UN3480', 'UN3481', 'UN3090', 'UN3091', 'UN3551', 'UN3552']
  const unCodeArr2 = ['UN3556', 'UN3171']
  const labelList = []
  const list1 = listPackagingD.filter(item => unCodeArr1.includes(item.unCode))
  const list2 = listPackagingD.filter(item => unCodeArr2.includes(item.unCode))

  if (list1.find(item => item.exemptFlag === '0')) {
    labelList.push('unExempt')
  } else {
    list1.forEach(v => {
      if (v.exemptFlag === '1') {
        labelList.push(v.unCode)
      }
    })
  }
  if (list2.length) {
    labelList.push('UN3556')
  }
  if (labelList.length) {
    store.commit('SET_UNCODE_LABEL_LIST', labelList)
    store.commit('SET_UNCODE_LABEL_DIALOG_SHOW', true)
  }
}

export const commPrint = async (obCheckM, listLabel,param) => {
  console.log('commPrint, obCheckM: ', JSON.stringify(obCheckM), '包裹标签: ', JSON.stringify(listLabel))
  // 清除未开启云打印标识
  window.localStorage.setItem('notOpenCloudPrinter', '0');

  printStart({
    aNode:'PC-单包裹-打印箱签',
    billNo:obCheckM.outboundNo||'', //单号
  })
  let systemId = await shipmentService.getSystemId();
  // 全球购
  if (systemId == checkConstant.SYSTEMID_CLOUD) {
    for (const lb of listLabel) {
      console.log("暂不支持");
      // executePaperlessPackageTagCloudPrint(systemId, obCheckM, lb, orderInvoiceInfo);
    }
  }
  // EPT
  else if (systemId == checkConstant.SYSTEMID_EPT) {
    for (const lb of listLabel) {
      console.log("暂不支持");
      // executePaperlessPackageTagEptPrint(systemId, obCheckM, lb, orderInvoiceInfo);
    }
  }
  // 印尼
  else if (systemId == checkConstant.SYSTEMID_ID) {
    console.log("暂不支持");
  }
  // 通用
  else {
    /**
     * 判断单据类型，1-自营；6-ECLP；其他-仓对接的外单；
     * 1、自营单据打印京东面单；
     * 2、ECLP单据根据ECLP下发的面单信息判定，打印不同的面单
     *   1)faceSheetFlag=1-纯仓业务，faceOrderJfsId为空，打印京东面单；
     *   2)faceSheetFlag=1-纯仓业务，faceOrderJfsId不为空，打印ECLP外单面单；
     *   3)faceSheetFlag=2-仓配业务，调用青龙接口获取并打印3PL面单
     * 3、其他-仓对接的外单打印京东面单；
     */
    let packageDetailed = []
    if(!_.isEmpty(param) && !_.isEmpty(param.listPackagingD)){
      packageDetailed = param.listPackagingD
    }
    let commonDTO = {
      orgNo: userInfo.orgNo,
      distributeNo: userInfo.distributeNo,
      warehouseNo: userInfo.warehouseNo
    };
    let warehouseInfo = await getOrgWarehouseName(commonDTO);
    if (obCheckM.resource == 1) {
      // 自营-打印京东面单
      let timeConSta = new Date().getTime();
      let orderInvoiceInfo = await getOrderInvoiceInfoGlobalization(obCheckM.outboundNo);
      let timeConEnd = new Date().getTime();
      console.log(orderInvoiceInfo, 'orderInvoiceInfo');
      console.log("SorderInvoiceInfo耗时------------》：" + (timeConEnd - timeConSta));
      for (const lb of listLabel) {
        console.log('自营lb----->', lb);
        // collectLabelInfo({type: waybillTypeMapping[0], size: ''});
        await executePaperlessPackageTagNewPrint(systemId, obCheckM, lb, orderInvoiceInfo,packageDetailed,warehouseInfo);
      }
      printEnd(true)
    }
    else if (obCheckM.resource == 6) {
      let labelType = obCheckM.labelType;
      // todo 兼容老逻辑，若面单类型不存在，从扩展信息获取面单信息，后续可以去掉
      let timeBegin = new Date().getTime();
      let faceInfo = await shipmentService.getFaceInfo({outboundNo: obCheckM.outboundNo});
      console.log('faceInfo===>', faceInfo)
      let timeEnd = new Date().getTime();
      console.log("复核---获取面单尺寸信息耗时：" + (timeEnd - timeBegin));
      // pushPrintPoint('wave_getFaceInfo',timeEnd - timeBegin)
      commonAddLog('PaperlessPackageTag.js$commPrint()',obCheckM.outboundNo,`复核---获取面单尺寸信息耗时：${(timeEnd - window.$processingBarCodeInputTimeBegin)}`, {cost: timeEnd - window.$processingBarCodeInputTimeBegin})
      //组装打印call单失败的替换页
      let callFailedInfo = {}
      callFailedInfo.outboundNo = obCheckM.outboundNo;
      callFailedInfo.packageNo = listLabel[0].packageNo;
      callFailedInfo.ownerNo = obCheckM.ownerNo;
      if (!labelType) {
        // 如果获取到的面单信息为空，报错返回
        if (_.isEmpty(faceInfo)) {
          callFailedInfo.errorMassage = "Get the Face Sheet information issued by FOP is not empty.";
          //执行打印call单失败的替换页
          await printCallLabelFailedReplaceTab(callFailedInfo)
          // $notify.error(i18n.t('eclpIssueFaceInfoIsEmpty'))
          customizeNotifyWithVoice(NOTIFY_TYPE_ENUM.error, i18n.t('eclpIssueFaceInfoIsEmpty'))
          return;
        }
        // 如果获取到的面单标签为空，报错返回
        if (!faceInfo.faceSheetFlag) {
          // $notify.error(i18n.t('faceSheetFlagIsEmpty'))
          customizeNotifyWithVoice(NOTIFY_TYPE_ENUM.error, i18n.t('faceSheetFlagIsEmpty'))
          return;
        }
        labelType = faceInfo.faceSheetFlag;
        // 如果faceSheetFlag=1 同时 faceOrderJfsId 有值：打印FOP下传面单（外单面单、仓配面单）
        if (labelType === 1 && !_.isEmpty(faceInfo.faceOrderJfsId)) {
          labelType = 2;
        }
        // else if (labelType === 2) {
        //   console.log("进入labelType由2改到3逻辑")
        //   labelType = 3;
        // }
      }

      console.info("labelType=" + labelType);
      if (labelType !== 1 && labelType !== 2 && labelType !== 3) {
        // $notify.error(i18n.t('faceSheetFlagIsIllegal'))
        customizeNotifyWithVoice(NOTIFY_TYPE_ENUM.error, i18n.t('faceSheetFlagIsIllegal'))
        return;
      }
      // 纯仓（lableType=1）：打Packing List和交接单，仓配（lableType=3）只打面单和Packing List。
      // 1.纯仓业务
      if (labelType === 1) {
        console.log("打印纯仓面单...");
        let timeConSta = new Date().getTime();
        let orderInvoiceInfo = await getOrderInvoiceInfoGlobalization(obCheckM.outboundNo);
        let timeConEnd = new Date().getTime();
        console.log("SorderInvoiceInfo耗时------------》：" + (timeConEnd - timeConSta));
        // wuchangzhou3 加入根据仓维度判断逻辑是否打印纯仓面单
        //https://cf.jd.com/pages/viewpage.action?pageId=388770861
        let ONLY_WAREHOUSE_IS_PRINT=await getSysConfigByKey('ONLY_WAREHOUSE_IS_PRINT');
        //ONLY_WAREHOUSE_IS_PRINT 在bs_systemconfig表中配置 取值value=1打印 value=0不打印
        // 纯仓业务根据仓的配置判断是否打印 create by wucahngzhou3 2021.7.8
        if((ONLY_WAREHOUSE_IS_PRINT!=null&&ONLY_WAREHOUSE_IS_PRINT!='')&&ONLY_WAREHOUSE_IS_PRINT=='0'){
          return;
        }
        //自提和仓站一体 不打印面单
        if(obCheckM.sendType && (obCheckM.sendType == 1 || obCheckM.sendType == 8)){
          console.log("obCheckM.sendType 自提和仓站一体 不打印面单",obCheckM.sendType)
          return;
        }
        if(obCheckM.KKCallSheetFlag && _.isEmpty(packageDetailed)){
          let timeBegin = new Date().getTime();
          const packageDetailInfo=await getCommonPackageDetail(obCheckM.outboundNo)
          let timeEnd = new Date().getTime();
          // pushPrintPoint('getPackageDByOutboundNo',timeEnd - timeBegin)
          obCheckM.packageDetailInfo=packageDetailInfo
        }
        if(!!obCheckM.KKCallSheetFlag){
          const pcakgeMList = await getPackageMList(obCheckM.outboundNo)
          if(!_.isEmpty(pcakgeMList)){
            listLabel = pcakgeMList
          }
        }
        obCheckM.allPackageQty=listLabel.length
        for (const lb of listLabel) {
          console.log('纯仓lb---->', lb);
          // collectLabelInfo({type: waybillTypeMapping[0], size: faceInfo.faceSize});
          await executePaperlessPackageTagNewPrint(systemId, obCheckM, lb, orderInvoiceInfo,packageDetailed,warehouseInfo);
        }
        printEnd(true)
        return;
      }

      // 2.外单业务
      if (labelType === 2) {
        console.log("打印外单面单...");
        changeANode('PC-打印-打印外单')
        setFaceSheetStyle(faceInfo.faceSize);
        let labels = []
        let nonLabels = []
        try {
          const labelInfos = await getOrderFace(obCheckM.outboundNo);
          if (!_.isEmpty(labelInfos)) {
            labelInfos.forEach(item => {
              if (item.faceOrderAddress &&
                (item.labelType === shipmentLabelType.forward_label ||
                item.labelType === shipmentLabelType.reverse_label ||
                item.labelType === shipmentLabelType.order_reverse_label ||
                (item.labelType === shipmentLabelType.zhuimi_label && obCheckM.isRepairPrint !== 1))
              ) {
                // if(!_.isEmpty(item.face)){
                //   labels.push(item.face)
                // }else {
                //   labels.push(item.faceOrderAddress)
                // }
                labels.push(item)
              } else {
                // 非面单附件打印
                nonLabels.push(item)
              }
            })
          }
        } catch (e) {
          console.error("获取面单失败labelType=2：", e);
        }
        // // todo 兼容老逻辑，后续可以去掉这部分
        // if (_.isEmpty(labels)) {
        //   let faceInfo = await shipmentService.getFaceInfo({outboundNo: obCheckM.outboundNo});
        //   if (faceInfo && faceInfo.face) {
        //     labels.push(faceInfo.face)
        //   }
        // }

        if (_.isEmpty(labels)) {
          try {
            // $notify.error(i18n.t('eclpIssueFaceInfoIsEmpty'));
            customizeNotifyWithVoice(NOTIFY_TYPE_ENUM.error, i18n.t('eclpIssueFaceInfoIsEmpty'))
          } catch (e) {
            console.error("获取ECLP下发的面单信息为空！", e);
          }
          return;
        }

        let printSeq = 0;
        // 需打印面单个数和获取的面单个数
        if (listLabel.length && labels.length > 1) {
           // 如果没有复核完成并且不是复核打包就不打印面单
          if(param && !param.isOrderCheckFinish && param.packType === 1){
            return;
          }
          for (const lb of labels) {
            console.log('外单lb---->', lb);
            // collectLabelInfo({type: waybillTypeMapping[0], size: faceInfo.faceSize});
            await executeECLPExternalOrderPackageTagCommonPrint(obCheckM, lb, printSeq);
            printSeq = printSeq + 1;
          }
          printEnd(true)
          return;
        }
        // todo 兼容老逻辑，后续可以去掉这部分
        if (listLabel.length && labels.length === 1) {
          for (const lb of listLabel) {
            await executeECLPExternalOrderPackageTagCommonPrint(obCheckM, labels[0], printSeq);
            printSeq = printSeq + 1;
          }
          printEnd(true)
          return;
        }
        // 非面单附件打印逻辑
        if (obCheckM && obCheckM.fullPackageFinish && !_.isEmpty(nonLabels)) {
          for (const nonLabel of nonLabels) {
            await printNonLabelsBySize(nonLabel, obCheckM)
          }
          return
        }
        // $notify.error(i18n.t('faceNumberInconsistent'))
        customizeNotifyWithVoice(NOTIFY_TYPE_ENUM.error, i18n.t('faceNumberInconsistent'))
        return;
      }
      // 3.仓配业务
      // 如果是单包裹并且不是重打，打印下传面单，否则调用青龙接口打印面单
      if (labelType === 3) {
        setFaceSheetStyle(faceInfo.faceSize);
        console.log("打印仓配面单...");
        // 是否已经打印过危险品面单
        let alreadyPrintAdr = false;

        // 获取禁止重打包标识
        const orderAction = initOrderActions(obCheckM.wmsOrderMark);
        // 正逆一体化标识
        obCheckM.forwardAndReverse = orderAction.forwardAndReverse;
        const forbidRepack = orderAction.forbidRepack && !obCheckM.selfDeliveryFlag;
        // 是否触发二次call单 (耗材采集+二次call单标识确认)
        let secondCall3PL=false;
        if (obCheckM.enableConsumblesScan && obCheckM.secondOrderFlag === 1) {
          console.log('触发二次call单, obCheckM: ', JSON.stringify(obCheckM), '包裹标签: ', JSON.stringify(listLabel))
          //二次call单标识置为true
          secondCall3PL=true;
        }
        // obCheckM.isOnlyOneFullPackage == null 适配 非复核打包
        // obCheckM.isOnlyOneFullPackage == true 代表单个订单只打了一个包裹
        // 适配非复核打包
        console.log(obCheckM.isOnlyOneFullPackage)
        if(listLabel.length === 1 && !obCheckM.rePackaged && obCheckM.isOnlyOneFullPackage == null){
          obCheckM.isOnlyOneFullPackage = true
        }

        FeAddlog.addLog('commPrint', '仓配业务打印面单单包裹判断', {
          outboundNo: obCheckM?.outboundNo,
          listLabelLength: listLabel?.length,
          isOnlyOneFullPackage: obCheckM?.isOnlyOneFullPackage,
          enableConsumblesScan: obCheckM?.enableConsumblesScan,
          secondOrderFlag: obCheckM?.secondOrderFlag,
          isRepairPrint: obCheckM?.isRepairPrint,
          rePackaged: obCheckM?.rePackaged,
          shippingPaperOrder: obCheckM?.shippingPaperOrder,
          forbidRepack: forbidRepack
        });
        // 单包裹
        // isRepairPrint 1 表示补打 secondCall3PL true 表示二次call单需要调用3pl重新获取面单打印
        const printDirectly = !obCheckM.rePackaged && !obCheckM.shippingPaperOrder;
        if (listLabel.length === 1 && obCheckM.isOnlyOneFullPackage && !secondCall3PL && obCheckM.isRepairPrint !== 1 && (printDirectly || forbidRepack)) {
          // 从ob_shipment_label表中中获取面单信息
          let face;
          let labelInfos
          let faceOrderAddress;
          try {
            let timeBegin = new Date().getTime();
            labelInfos = await getOrderFace(obCheckM.outboundNo);
            console.log('labelInfos===>', labelInfos);
            let timeEnd = new Date().getTime();
            console.log("复核---仓配业务获取面单信息耗时：" + (timeEnd - timeBegin));
            commonAddLog('PaperlessPackageTag.js$commPrint()-labelType3',obCheckM.outboundNo,`复核---仓配业务获取面单信息耗时：${(timeEnd - window.$processingBarCodeInputTimeBegin)}`, {cost: timeEnd - window.$processingBarCodeInputTimeBegin})
            // if(labelInfos != null && 1801375 == labelInfos){
            //   $notify.success(i18n.t('complete'))
            // }
          } catch (ex) {
            FeAddlog.addLog('commPrint', '仓配业务打印面单获取面单失败', {
              outboundNo: obCheckM?.outboundNo,
              ex: ex
            });
            console.error("获取面单失败：", ex)
          }
          if (!_.isEmpty(labelInfos) && labelInfos.length === 1) {
            face = labelInfos[0].face;
            faceOrderAddress = labelInfos[0].faceOrderAddress
          }
          // TODO: 先判断仓内系统参数是否配置了zpl打印,是则优先拿zpl打印，否则打印png,还没有成功再去请求3pl，最后异常提示

          if (!_.isEmpty(labelInfos) && labelInfos.length > 1) {
            console.info('FOP下发了多个单据labelInfos:' + JSON.stringify(labelInfos))
            // 单包裹只取一个正向面单 其他非面单附件单独处理
            let nonLabelInfos = []
            labelInfos.forEach(item => {
              if (item.faceOrderAddress &&
                (item.labelType === shipmentLabelType.forward_label ||
                  item.labelType === shipmentLabelType.zpl)) {
                    // face = labelInfos[0].face
                    // faceOrderAddress = labelInfos[0].faceOrderAddress
                    try {
                      if (item.faceOrderAddress != faceOrderAddress) {
                        FeAddlog.addLog('commPrint labelInfos多个', '不相等', {
                          outboundNo: obCheckM.outboundNo,
                          itemFaceOrderAddress: item.faceOrderAddress,
                          faceOrderAddress: faceOrderAddress
                        })
                      }
                    } catch (e) {
                      console.warn('commPrint labelInfos err', e);
                    }
                  face = item.face
                  faceOrderAddress = item.faceOrderAddress
              } else if (item.faceOrderAddress &&
                (item.labelType === shipmentLabelType.order_reverse_label ||
                  item.labelType === shipmentLabelType.shipping_paper ||
                  item.labelType === shipmentLabelType.package_invoice)) {
                // 逆向和shippingpaper的下边单独处理
              } else {
                // 打印随单下发的非面单附件信息
                nonLabelInfos.push(item)
              }
            })
            // 打印随单下发的非面单附件信息
            if (!_.isEmpty(nonLabelInfos)) {
              for (const nonLabel of nonLabelInfos) {
                await printNonLabelsBySize(nonLabel, obCheckM)
              }
            }

            // 判断是否打印shipping paper单
            let flag = await checkShippingPaperPrint(labelInfos)
            if(flag){
              // 只打印shipping_paper
              let labelInfo = await doShippingPaperPrint(labelInfos,obCheckM)
              if(labelInfo!== null){
                face = labelInfo.face;
                faceOrderAddress = labelInfo.faceOrderAddress
                collectLabelInfo({type: waybillTypeMapping[5], size: face.faceSize});
                console.info("打印shipping paper面单后，继续调用正向面单打印 labelInfo："+ JSON.stringify(labelInfo))
              }else{
                console.error("打印shipping paper面单后，无面单打印")
                return
              }
            }

            // 判断是否打印包裹维度发票
            let packageInvoiceFlag = await checkInvoicePrint(labelInfos)
            if(packageInvoiceFlag){
              // 只打印发票
              let labelInfo = await doInvoicePrint(labelInfos,obCheckM)
              if(labelInfo!== null){
                face = labelInfo.face;
                faceOrderAddress = labelInfo.faceOrderAddress
                collectLabelInfo({type: waybillTypeMapping[2], size: face.faceSize});
                console.info("打印发票后，继续调用正向面单打印 labelInfo："+ JSON.stringify(labelInfo))
              }else{
                console.error("打印包裹维度发票面单后，无面单打印")
                return
              }
            }

            // 判断是否打印逆向面单
            let reverseflag = await checkReversePrint(labelInfos)
            if(reverseflag){
              console.info("打印逆向面单 labelInfos:" + JSON.stringify(labelInfos))
              // 只打印逆向面单
              let labelInfo = await doReversePrint(labelInfos, obCheckM)
              if(labelInfo!== null){
                face = labelInfo.face;
                faceOrderAddress = labelInfo.faceOrderAddress
                collectLabelInfo({type: waybillTypeMapping[1], size: face.faceSize});
                console.info("打印逆向面单后，继续调用正向面单打印 labelInfo:" + JSON.stringify(labelInfo))
              }else{
                printEnd(true)
                console.error("打印逆向面单后，无面单打印")
                return
              }
            }
          }

          // 打印adr -- 单包裹明细中有危险品和带电净重才去调用
          // listPackagingD 当前（商品维度）
          // listPackageD 是整个的
          // listPackageM （包裹主档/长宽高等明细，打了几个包裹）
          // unCode （危险品的码） 有值表示是危险品
          // obCheckM 订单的所有内容
          if (param && param.listPackagingD && !_.isEmpty(param.listPackagingD)) {
            alreadyPrintAdr = true
            let printAdrByEDISwitch = 0
            const isExistUnCode = param.listPackagingD.find(item => item.unCode && item.outboundNo === obCheckM.outboundNo)
            const isExistBatteryNetWeight = param.listPackagingD.find(item => item.batteryNetWeight && item.outboundNo === obCheckM.outboundNo)
            const needPrintAdrLabel = isExistUnCode && isExistBatteryNetWeight
            if (needPrintAdrLabel) {
              // 危险品标签提示
              showUnCodeLabelDialog(param.listPackagingD)
              printAdrByEDISwitch = await getSysConfigByKey('PrintAdrImdg_ByEDI_Switch')
              const isNewPrintMethod = +printAdrByEDISwitch === 1; // 系统参数配置，决定是否走老流程
              const printAdrImdgFlag = obCheckM.printAdrImdgFlag // 新流程下是否打印adr  1打印 0不打印
              commonAddLog('单包裹明细危险品参数组装&打印adr',obCheckM.outboundNo,`参数校验---执行打印前：isExistUnCode=${isExistUnCode} isExistBatteryNetWeight=${isExistBatteryNetWeight}`)
              console.log('isExistUnCode', isExistUnCode)
              console.log('isExistBatteryNetWeight', isExistBatteryNetWeight)
              if (isNewPrintMethod && printAdrImdgFlag === 1) {
                obCheckM.specifiedTemplate = 1
              } else {
                obCheckM.specifiedTemplate = 0
              }
              if (!isNewPrintMethod || obCheckM.specifiedTemplate === 1) {
                await buildParamsAndPrintAdrByOne(obCheckM, param)
              }
            }
          }
          
          // todo 兼容老逻辑，从ob_expand中获取面单信息
          if (_.isEmpty(face)) {
            face = faceInfo.face;
          }
          if (!_.isEmpty(face) || !_.isEmpty(faceOrderAddress)) {
            // 打印正向面单逻辑
            commonAddLog('PaperlessPackageTag.js$commPrint()-labelType4',obCheckM.outboundNo,`复核---进打印之前：${(new Date().getTime() - window.$processingBarCodeInputTimeBegin)}`, {cost: (new Date().getTime() - window.$processingBarCodeInputTimeBegin)})
            try {
              console.info("正向面单打印 face:" + JSON.stringify(face) +" faceOrderAddress: "+ JSON.stringify(faceOrderAddress))
              // collectLabelInfo({type: waybillTypeMapping[0], size: faceInfo.faceSize});
            } catch (error) {
              commonAddLog('collectLabelInfoErrorCatch',obCheckM.outboundNo, JSON.stringify(error), {cost: (new Date().getTime() - window.$processingBarCodeInputTimeBegin)})
            }
            // console.info("正向面单打印 obCheckM:" + JSON.stringify(obCheckM))
            await executeECLPExternalOrderPackageTagPrint(obCheckM, face,faceOrderAddress, true);
            printEnd(true)

            console.log('executeECLPExternalOrderPackageTagPrint-param', JSON.stringify(param))
            commonAddLog('PaperlessPackageTag.js$commPrint()-labelType5',obCheckM.outboundNo,`复核---进打印之后：${(new Date().getTime() - window.$processingBarCodeInputTimeBegin)}`, {cost: (new Date().getTime() - window.$processingBarCodeInputTimeBegin)})

            return
          }
          if (forbidRepack) {
            return;
          }
        }

        // 多包裹
        //如果faceSheetFlag=2 同时 faceOrderJfsId 有值：打印FOP下传面单（外单面单、仓配面单）
        let perWeight = (obCheckM.totalWeight/listLabel.length).toFixed(2)
        console.log("obCheckM重量"+obCheckM.totalWeight+"perWeight"+perWeight+"耗材重量"+obCheckM.consumableWeight)
        if(perWeight == null ||perWeight ==''){
          perWeight =0
        }
        let packageList = [];
        console.log(obCheckM, listLabel)
        // listLabel里没有信息，重新给赋值一下。
        if(param && param.listPackagingD){
          for(let lb of listLabel){
            for(let packageD of param.listPackagingD){
              if(lb.packageNo === packageD.packageNo){
                lb.isOriginalConsumable = packageD.isOriginalConsumable
                // 非大疆DHL按托call单场景，否则在下边赋值
                if (!lb.isCallByPalletFlag) {
                  lb.length = packageD.length
                  lb.width = packageD.width
                  lb.height = packageD.height
                }
              }
            }
          }
        }
        for (let lb of listLabel) {
          let p = {};
          p.packageID = lb.packageNo;
          //包裹明细重量取所有商品重量之和 包裹标签上复核打包赋值了 checkM上独立打包赋值了
          if (lb.enableFullPackage || obCheckM.enableFullPackage) {
            p.weight = Number.parseFloat(lb.packageWeight);
          } else {
            p.weight = Number.parseFloat(perWeight);
          }
          if (p.weight) {
            p.weight = _.round(p.weight, 2);
          }
          // 这块有人在中间传了另外封装的包裹.listLabel里取不到信息 ，上面给重新赋值了
          p.length = lb.isOriginalConsumable ? lb.length : (lb.consumableLength ? lb.consumableLength : obCheckM.consumableLength);
          p.width =  lb.isOriginalConsumable ? lb.width : (lb.consumableWidth ? lb.consumableWidth :  obCheckM.consumableWidth);
          p.height = lb.isOriginalConsumable ? lb.height : (lb.consumableHeight ? lb.consumableHeight : obCheckM.consumableHeight);

          // 大疆DHL按托call单特殊场景
          if (lb.isCallByPalletFlag) {
            p.length = lb.length;
            p.width = lb.width;
            p.height = lb.height;
          }

          // 没有耗材采集并且数量是1
          if(obCheckM.tailPackageType){
            p.packingType = obCheckM.tailPackageType
          }
          if(!_.isEmpty(param) && !_.isEmpty(param.listPackagingD)){
            let goods=[]
            let tmpPackageInfo = {}
            let goodsQty = 0;
          //  console.log('组装明细：' + JSON.stringify(param))
          //  console.log('lb：' + JSON.stringify(lb))
           for(let packageD of param.listPackagingD) {

             if (packageD.outboundNo == lb.outboundNo && packageD.packageOrder == lb.packageOrder) {
               let good={}
              // HKM增加下发参数 https://joyspace.jd.com/pages/oWr9M44ejnYJpZZpng81
              good.claimValue = packageD.price;
              good.currency = packageD.currency;
              good.hsCode = packageD.hsCode;
              good.sourceCountry = packageD.sourceCountry;
              
              good.customerGoodsCode = packageD.goodsAliasCode;

               good.goodsCount = packageD.checkQty
               good.goodsNo =  packageD.goodsNo
               good.goodsCode =  packageD.goodsNo
               good.goodsName =  packageD.goodsName
               good.unCode = packageD.unCode
               good.goodsBarcode = packageD.goodsBarcode
               if (good.unCode && good.unCode !== '') {
                 good.goodsWeightUnits = packageD.weightUnit
                 good.goodsWeight = packageD.batteryNetWeight
                 good.batteryCapacity = packageD.batteryCapacity
                 good.capacityUnit = packageD.capacityUnit
               }else{
                 good.goodsWeightUnits = packageD.weightUnit
                 good.goodsWeight = packageD.weight
               }
               tmpPackageInfo.length = packageD.length
               tmpPackageInfo.width = packageD.width
               tmpPackageInfo.height = packageD.height
               goodsQty = goodsQty + good.goodsCount
               goods.push(good)
               // 包裹明细的尾程包装类型赋值到包裹上
               if(packageD.tailPackageType){
                 p.packingType = packageD.tailPackageType
               }

             }
           }
           p.goods = goods
          if (!p.length&& !p.width && !p.height&& !lb.consumableLength && goods.length === 1 && goodsQty === 1) {
            p.length = tmpPackageInfo.length
            p.width = tmpPackageInfo.width
            p.height = tmpPackageInfo.height
          }
         }
          packageList.push(p);
        }
        try {
          console.log('调用3PL打单：' + JSON.stringify(faceInfo))
          console.log('调用3PL打单 packageList：' + JSON.stringify(packageList))
          // collectLabelInfo({type: waybillTypeMapping[0], size: faceInfo.faceSize});
          changeANode('PC-多包裹/实时call3Pl-打印箱签')
          let res = {};
          const {selfDeliveryFlag, selfDeliveryUrlFlag, labelContent, totalWeight} = obCheckM;
          if (selfDeliveryFlag) {
            const pkgNum = listLabel.length;
            // 沙特起网特殊逻辑，支持云打印3.0
            if (selfDeliveryUrlFlag) {
              const contentList = buildShate1plPrintParams(labelContent, listLabel, obCheckM, totalWeight);
              for (let item of contentList) {
                console.log('1plitme', item)
                const result = await getLabelsForSelfCloudPrint(item);
                const content = {
                  templateId: 45,
                  printPDF: 1,
                  pdfSrc: result.base64Url,
                  data: {
                    picture: result.faceUrl
                  }
                }
                await print(content);
                commonAddLog('沙特自营面单', obCheckM.outboundNo, `包裹号：${item.packageNo} 包裹总数：${item.packageCount}`)
              }
            } else {
              if (pkgNum > 1) {
                if (obCheckM.isRepairPrint === 1) {
                  const {obPackageMList} = obCheckM;
                  const contentList = buildCloudPrintParamForRepairPrint(labelContent, obPackageMList, totalWeight);
                  for (let content of contentList) {
                    await print(content);
                    commonAddLog('自营面单补打（多包裹）', obCheckM.outboundNo, `包裹序号：${content.data?.packageIndex} 包裹总数：${content.data?.packageCount}`)
                  }
                } else {
                  const contentList = buildCloudPrintParamForMultiPack(labelContent, pkgNum, listLabel, totalWeight);
                  for (let content of contentList) {
                    await print(content);
                    commonAddLog('自营面单打单（多包裹）', obCheckM.outboundNo, `包裹序号：${content.data?.packageIndex} 包裹总数：${content.data?.packageCount}`)
                  }
                }
              } else {
                console.log('1plPrint', labelContent)
                const weight = (listLabel.length && listLabel[0].packageWeight) || totalWeight;
                let content = {};
                if (obCheckM.isRepairPrint === 1 && obCheckM.obPackageMList?.length) {
                  content = buildCloudRepairPrintParam(labelContent, weight, listLabel, obCheckM);
                } else {
                  content = buildCloudPrintParam(labelContent, weight, listLabel, obCheckM);
                }
                await print(content);
                commonAddLog('自营面单打单（单包裹）', obCheckM.outboundNo, `是否补打：${+obCheckM.isRepairPrint === 1 ? '是' : '否'}`)
              }
            }
          } else {
            res = await executePaperlessPackageTag3PLPrint(obCheckM, packageList, faceInfo.extMap, param, alreadyPrintAdr);
          }
          printEnd(true)
          return res
        } catch (e) {
          console.error('调用青龙接口获取并打印3PL面单发生异常：' + e)
          // 只有hkm的单子才阻塞，抛出异常。
          if (obCheckM.waveType === 60 && (obCheckM.orderExtraFlag && [1, 2].includes(obCheckM.orderExtraFlag))) {
            customizeNotifyWithVoice(NOTIFY_TYPE_ENUM.error, i18n.t('saveShipNoFailure'))
          }
        }
        // 多包裹 整单复核完后打印随单下发的非面单附件信息
        if (obCheckM && obCheckM.fullPackageFinish) {
          let labelInfos
          let nonLabelInfos = []
          try {
            let timeBegin = new Date().getTime()
            labelInfos = await getOrderFace(obCheckM.outboundNo);
            console.log('labelInfos===>', labelInfos)
            let timeEnd = new Date().getTime()
            console.log('复核---仓配业务多包裹获取非面单信息耗时：' + (timeEnd - timeBegin))
            commonAddLog('PaperlessPackageTag.js$commPrint()-labelType3', obCheckM.outboundNo, `复核---仓配业务获取面单信息耗时：${(timeEnd - timeBegin)}`,  {cost: timeEnd - timeBegin})
            // if (labelInfos != null && 1801375 == labelInfos) {
            //   $notify.success(i18n.t('complete'))
            // }
          } catch (ex) {
            console.error('复核---仓配业务多包裹获取非面单信息失败：', ex)
          }
          if (!_.isEmpty(labelInfos)) {
            labelInfos.forEach(item => {
              // 非面单附件 shipping_paper较为特殊 多包裹场景是从3pl获取后打印 所以这里也不打印
              if (item.faceOrderAddress &&
                item.labelType !== shipmentLabelType.forward_label &&
                item.labelType !== shipmentLabelType.reverse_label &&
                item.labelType !== shipmentLabelType.order_reverse_label &&
                item.labelType !== shipmentLabelType.shipping_paper &&
                item.labelType !== shipmentLabelType.package_invoice &&
                item.labelType !== shipmentLabelType.zpl) {
                nonLabelInfos.push(item)
              }
            })
            if (!_.isEmpty(nonLabelInfos)) {
              for (const nonLabel of nonLabelInfos) {
                await printNonLabelsBySize(nonLabel, obCheckM)
              }
            }
          }
        }
      }
    } else {
      // 其他-仓对接的外单，打印京东面单
      obCheckM.allPackageQty=listLabel.length
      for (const lb of listLabel) {
        console.log('其他lb----->', lb);
        // collectLabelInfo({type: waybillTypeMapping[0], size: ''});
        await executePaperlessPackageTagNewPrint(systemId, obCheckM, lb, orderInvoiceInfo,packageDetailed,warehouseInfo);
      }
      printEnd(true)
    }
  }
}

const printNonLabelsBySize = async (nonLabel, obCheckM) => {
  const imgType = judgeImgType(nonLabel.face) || judgeImgType(nonLabel.faceOrderAddress);
  const isPdf = imgType === 'pdf'
  if (nonLabel.labelSize === '210*297') {
    let content = {}
    content.templateId = 10 // A4通用模板
    if (isPdf) {
      content.printPDF = 1
      content.pdfSrc = nonLabel.face
    }
    let data = {}
    content.data = data
    data.picture = nonLabel.faceOrderAddress
    await print(content)
  } else if (nonLabel.labelSize === '297*210') {
    // 横板A4通用模板
    let content = {}
    if (isPdf) {
      content.printPDF = 1
      content.pdfSrc = nonLabel.face
    }
    content.templateId = 101
    let data = {}
    content.data = data
    data.picture = nonLabel.faceOrderAddress
    await print(content)
  } else {
    // 其他尺寸默认都用浏览器打印
    let faceInfo = await shipmentService.getFaceInfo({ outboundNo: obCheckM.outboundNo })
    setFaceSheetStyle(!_.isEmpty(faceInfo) ? faceInfo.faceSize : '')
    if (isPdf) {
      const faceAddress = judgeImgType(nonLabel.face) ?  nonLabel.face : nonLabel.faceOrderAddress
      printByImgType(faceAddress)
    } else {
      printByImgType(nonLabel.face)
    }
  }
}

export const getOrderPackageTagInfoID = async (outboundNo) => {
  let invoiceQuery = {};
  invoiceQuery.outboundNo = outboundNo;
  let packageTagOrderInfoIDList = await shipmentService.getOrderPackageTagInfoID(invoiceQuery);
  if (!packageTagOrderInfoIDList || packageTagOrderInfoIDList.length <= 0) {
    $notify.error(i18n.t('idPackageTagOrderInfoNull'));
    return null;
  }
  let packageTagOrderInfoID = packageTagOrderInfoIDList[0];
  //支付方式
  packageTagOrderInfoID.payTypeValue = payTypeConstant.getPayTypeValue(packageTagOrderInfoID.payType);
  return packageTagOrderInfoID;
}

export const executePaperlessPackageTagNewPrint = async (systemId, obCheckM, pkLabel, orderInvoiceInfo,packageDetailed,warehouseInfo) => {
  try {
    let tag = obCheckM.packageTag;
    // 获取master配置的是否隐藏客户姓名和电话的信息
    if (obCheckM.stationType && obCheckM.stationType.length > 0) {
      //订单信息stationType字段不为空，取master的配置信息
      let tempCheckM = {};
      tempCheckM.stationType = obCheckM.stationType;
      tempCheckM = shipmentService.qryPackageTagHideInfo(tempCheckM);
      if (!tempCheckM) { //获取为空，默认隐藏
        obCheckM.isHideName = 1;
        obCheckM.isHidePhone = 1;
      } else {
        obCheckM.isHideName = tempCheckM.isHideName;
        obCheckM.isHidePhone = tempCheckM.isHidePhone;
      }
    } else {
      obCheckM.isHideName = 0;
      obCheckM.isHidePhone = 0;
    }

    // 空|催、店|柜|提、众标记【1】
    let strSignText = paperlessPackageTagHelper.getOrderSign(obCheckM);

    // 显示订单标记：奢（奢侈品）、闪（闪购）、节（节能补贴）、增（赠品订单）【8】
    let luxuryText = paperlessPackageTagHelper.getOrderTag(obCheckM);

    // 发票标记【12】
    let normalText = paperlessPackageTagHelper.getOrderInvoicInfo(obCheckM);

    // 发票标记【12】订单配送时效性【14】
    let strTimeCategory = paperlessPackageTagHelper.getOrderTimeCategory(obCheckM, orderInvoiceInfo);

    // 发票标记【12】订单标题+支付方式【15】 值无引用 注释
    // let warehouseText = paperlessPackageTagHelper.getOrderWarehouseText(obCheckM);

    // 客户信息地址【16】
    let strAddress = paperlessPackageTagHelper.getOrderCustomerAddress(obCheckM, tag);

    // 应收金额【17】
    let strAmount = paperlessPackageTagHelper.getOrderCustomerAmount(systemId, obCheckM, tag, orderInvoiceInfo);

    // 包裹订单号OR运单号条形码【19】
    let barCode = paperlessPackageTagHelper.getOrderBarCode(obCheckM);

    // 备注【20】
    let remark = paperlessPackageTagHelper.getOrderRemark(obCheckM, orderInvoiceInfo);

    // 纯仓通用面单Remark栏信息
    let newRemark = paperlessPackageTagHelper.getNewOrderRemark(obCheckM);

    // 设置二维码的数据【21】
    let strPackageData = paperlessPackageTagHelper.getOrderPackageData(pkLabel);

    // 声明【22】
    let strComment = paperlessPackageTagHelper.getOrderComment(obCheckM, orderInvoiceInfo);

    // 会员标识
    let userLevel = paperlessPackageTagHelper.getUserLevel(obCheckM);

    // 包裹标签参数封装
    console.log("wms_package, packageWeight：" + pkLabel.packageWeight + "  customerName:" + orderInvoiceInfo.customerName + "  customerName2:" + orderInvoiceInfo.custName)

    //获取重量单位
    let weightUnit = await getSysConfigByKey('weightUnit')
    if(!weightUnit || !weightUnit.trim()){
      weightUnit='KG'
    }
    let data = {};
    data.packageCode = pkLabel.packageNo;
    data.orderNo = obCheckM.outboundNo;
    data.waybillCode = barCode;
    data.waveInfo = strTimeCategory;
    data.storeName = obCheckM.storeName;//始发仓库名称
    data.originalName = (tag == null) ? "" : tag.startDistributeName
    data.destinationName = (tag == null) ? "" : tag.targetDistriName // 目的分拣中心名称
    data.originalCode = obCheckM.warehouseNo; // 始发仓库编码
    data.warehouseName = warehouseInfo.warehouseName
    data.destinationCode = obCheckM.siteNo // 目的站点编码
    data.destinationStieName = obCheckM.siteName // 目的站点名称
    data.destinationDistributSite = (obCheckM.commonFaceSheet ? `${obCheckM.siteNo},` : '') + obCheckM.siteName
    data.originalCrossCode = (tag == null) ? "" : tag.startCrossCode;         //本地分拣中心道口
    data.originalTabletrolleyCode = (tag == null) ? "" : tag.startTabletrolleyCode;  //本地分拣中心笼车号
    data.destinationCrossCode = (tag == null) ? "" : tag.targetCrossCode;  //目的分拣中心道口
    data.destinationTabletrolleyCode = (tag == null) ? "" : tag.targetTabletrolleyCode; //目的分拣中心笼车号
    data.road = obCheckM.areaCode;//路区显示
    data.packageIndex = pkLabel.packageOrder + "/" + pkLabel.packageQty;//包裹编号
    data.packageTime = i18n.t(checkConstant.packText, [formatDateTime(new Date()), pkLabel.platformNo]);//包裹编号
    let packageWeight = Number.parseFloat(obCheckM.totalWeight).toFixed(2);
    data.packageWeight = `${packageWeight}  ${weightUnit}`;//包裹重量
    data.receiverProvince = obCheckM.receiverProvince
    data.isAdultFlag = obCheckM.isAdultFlag
    // 获取支付方式
    let paymentText = paperlessPackageTagHelper.getPaymentSignTai(obCheckM, orderInvoiceInfo);

    data.paymentText = paymentText;//支付类型
    data.printAddress = strAddress; //用户地址

    // 目前没有微笑面单需求，后续有该需求，再做改造，modified by yaogang at 2020年6月3日20:10:59
    //let newCustomerName = paperlessPackageTagHelper.getUserName(orderInvoiceInfo.customerName, obCheckM)
    let newCustomerName = orderInvoiceInfo.customerName
    data.customerName = newCustomerName;
    //let newTelephone = hiddenTelephone(obCheckM.tel, obCheckM.isHidePhone)
    let newTelephone = obCheckM.tel
    data.customerContacts = newTelephone
   //出库单号+客户订单号
    data.ECLPNO = obCheckM.outboundNo + "," + obCheckM.channelsOutboundNo;
    data.orderCode= obCheckM.channelsOutboundNo;
    data.ownerType= obCheckM.revenueClientType;
    // 业务方暂定不要备注信息 modified by yaogang138 at 2020年6月3日
    // data.comment= strComment;
    data.comment= '';

    // 处理条码
    data.packageCodeImg = barcode.getBarcode(data.packageCode);
    data.barcodeImg = barcode.getBarcode(data.waybillCode);

    // 包裹标签打印
    let timeBegin = new Date().getTime();
    let content = {};
    content.templatePath = printConst.OUTBOUND_PACK_PATH;
    content.printName = printConst.PRINT_ORDER;
    // 云打印增加模板和单号字段，删除条码字段
    if(!!obCheckM.KKCallSheetFlag){
        // KK面单
        // console.log('kk&orderInvoiceInfo=====',orderInvoiceInfo,pkLabel)
        const isKK=obCheckM.KKCallSheetFlag;
        let classification=''
      let kkOrderRemark = paperlessPackageTagHelper.getKKOrderRemark(obCheckM)
        if(!_.isEmpty(packageDetailed)){
          let goodsNoArr=[]
          for(let packageD of packageDetailed) {
            if (packageD.outboundNo == pkLabel.outboundNo && packageD.packageOrder == pkLabel.packageOrder) {
                goodsNoArr.push(packageD.goodsNo)
            }
          }
            classification= await getCatalogListByGoodsNo([...new Set(goodsNoArr)])
        }else if(obCheckM.packageDetailInfo){
            let goodsNoArr=[]
            for(let packageD of obCheckM.packageDetailInfo) {
              if (packageD.outboundNo == pkLabel.outboundNo && packageD.packageNo == pkLabel.packageNo) {
                goodsNoArr.push(packageD.goodsNo)
            }
            }
            classification= await getCatalogListByGoodsNo([...new Set(goodsNoArr)])
        }
         const packageWeight = Number.parseFloat(obCheckM.totalWeight).toFixed(2);
         const {outboundNo,channelsOutboundNo,carrierName,realCarrierName,carrierNo,storeNo,allPackageQty}=obCheckM
         const {packageNo,packageQty,packageOrder}=pkLabel
         content.templateId=37
         const params={
           address: strAddress,
           carrierName:realCarrierName,
           carrierNo,
           customerOrderNo:channelsOutboundNo,
           classification,
           outboundNo,
          // packageNo,
           packageNo:`${outboundNo}-${packageOrder}-${allPackageQty}`,
           packageQty:`${packageOrder}/${allPackageQty}`,
           packageWeight,
           weightUnit,
           remark:kkOrderRemark,
           storeNo,
           warehouseName: warehouseInfo.warehouseName,
           warehouseNo: userInfo.warehouseNo,
           packageCode : packageNo,
         }
      console.log('wms-KK package, print content:' + JSON.stringify(content))
      // 更新包裹 补打不更新KK包裹面单
      // if (obCheckM.isRepairPrint !== 1) {
      //   await modifyPackageNoByKK({
      //     packageNo: `${outboundNo}-${packageOrder}-${allPackageQty}`,
      //     outboundNo: outboundNo,
      //     packageOrder: packageOrder
      //   })
      // } else {
      //   params.packageNo = params.packageCode
      //   const parts =  params.packageCode.split('-');
      //   params.packageQty = parts[1] + '/' +parts[2]
      // }
      content.data = params
      // 调用云打印
      await print(content);
    }else{
      if (printConst.DEFINE_PRINT_WAY === printConst.PRINT_WAY.CLOUD_PRINT) {
        content.orderNum = obCheckM.outboundNo
        delete data.packageCodeImg
        delete data.barcodeImg
        content.data = data;
        if (obCheckM.commonFaceSheet == cloudPrintFaceLabelType.OLD_ORDER) {
          content.templateId = 1
        } else if (obCheckM.commonFaceSheet == cloudPrintFaceLabelType.NEW_ORDER) {
          content.templateId = 15
        } else if (obCheckM.commonFaceSheet == cloudPrintFaceLabelType.MCA_SELFPICKUP_NEW_LABEL) {
          content.templateId = 26 // 人工自提
          dealTel(obCheckM, content)
          dealTemp(obCheckM, content)
          data.tempDistriName = obCheckM.distributionName//临时分拣中心名称
          data.jitType = (obCheckM.jitType && obCheckM.jitType == 1) ? 'Same-Day' : ''
          if (obCheckM.sendType && obCheckM.sendType == 9){
            data.address = warehouseInfo.address
            data.expectedArrivalBeginTime = obCheckM.expectedArrivalBeginTime
            data.orderType = 'pickup'
//            data.pickupType = '1'
          }else if(obCheckM.sendType && obCheckM.sendType == 10) {
            content.templateId = 47 // 人工自提
            // 收货地址拼接
            // Kiotoweg,307,4303 BE,Rotterdam,Netherlands
            // 街道,门牌号,邮编,城市,国家
            // shipmentAddress,houseNumber,zip,city,receiverProvince
            let shippingAddress = `${obCheckM.address},${obCheckM.houseNumber},${obCheckM.zipCode},${obCheckM.city},${obCheckM.receiverProvince}`
            console.info("MCA配送转自提收货地址：" + shippingAddress)
            data.address = shippingAddress
            data.expectedArrivalBeginTime = obCheckM.outboundTime
            data.orderType = 'Delivery - LMD No blue box'
//            data.pickupType = '2'
          }else if (obCheckM.sendType && obCheckM.sendType == 11){
//             content.templateId = 48 // 自提柜
             data.address = obCheckM.address
             data.printOrderType = 3
             data.expectedArrivalBeginTime = obCheckM.expectedArrivalBeginTime
             data.orderType = 'Pickup-Locker'
//             data.pickupType = '3'
          }else if (obCheckM.sendType && obCheckM.sendType == 12){
              // 街道,门牌号,邮编,城市,国家
              // shipmentAddress,houseNumber,zip,city,receiverProvince
              let shipmentLineCode ='';
              console.log('orderRemark：'+obCheckM.orderRemark)
              if(obCheckM.orderRemark){
                  let firstIndex = obCheckM.orderRemark.indexOf(";")
                  shipmentLineCode = obCheckM.orderRemark.substring(0,firstIndex)
              }
              console.log('lineCode：'+shipmentLineCode)

              data.address = obCheckM.address+' '+obCheckM.houseNumber
              data.lineCode = shipmentLineCode
              data.zipCode = obCheckM.zipCode+' '+obCheckM.city
              data.receiverProvince=obCheckM.receiverProvince
              content.templateId = 51 // 自营配送
              data.expectedArrivalBeginTime = obCheckM.expectedArrivalBeginTime
              data.orderType = 'Ochama Delivery'
           }else if (obCheckM.sendType && obCheckM.sendType == 14){
              // 街道,门牌号,邮编,城市,国家
              // shipmentAddress,houseNumber,zip,city,receiverProvince
              console.log('mca-1pl orderRemark：'+obCheckM.orderRemark)
              data.lineCode = 'Carrier:TokoPoint'
              data.address = obCheckM.address+' '+obCheckM.houseNumber
              data.zipCode = obCheckM.zipCode+' '+obCheckM.city
              data.receiverProvince=obCheckM.receiverProvince
              content.templateId = 63 // 1PL配送
              data.expectedArrivalBeginTime = obCheckM.expectedArrivalBeginTime
              data.orderType = 'Ochama Delivery'
           }
        } else if (obCheckM.commonFaceSheet == cloudPrintFaceLabelType.INDONESIA_ORDER ||
          obCheckM.commonFaceSheet == cloudPrintFaceLabelType.OVERSEAS_ORDER) {
          // 打单改造 根据commonFaceSheet下载对应面单打印
          // 0：老面单，1：新面单，2：印尼, 3:德国等 ……(纯仓)
          console.log("进入打单改造新面单逻辑 commonFaceSheet:" + obCheckM.commonFaceSheet);
          let otherInfo = {
            strAddress : strAddress,
            strComment : newRemark,
            paymentText : paymentText,
            strTimeCategory : strTimeCategory,
            barCode : barCode,
            weightUnit : weightUnit
          }
          content = await printPureAndIndonesiaFaceLabel(obCheckM,orderInvoiceInfo,pkLabel,packageDetailed,otherInfo,warehouseInfo);
        }
        console.log("wms package, print content:" + JSON.stringify(content));
        // 调用云打印
        await print(content);
      }

    }

    let timeEnd = new Date().getTime();
    console.log("执行包裹标签打印耗时（" + pkLabel.packageNo + "）：" + (timeEnd - timeBegin) + "毫秒！"+"isKK面单"+!!obCheckM.KKCallSheetFlag);
    console.log("wms package, print param:" + JSON.stringify(data));
    commonAddLog('PaperlessPackageTag.js$executePaperlessPackageTagNewPrint()',obCheckM.outboundNo,`复核---执行包裹标签打印耗时：${(timeEnd - timeBegin)}`, {cost: timeEnd - timeBegin})
  } catch (error) {
    console.log("执行包裹标签打印报错：" + error);
  }
}
export const modifyPackageNoByKK = async (params) => {
  try {
    await modifyPackageNo(params)
    // pushPrintPoint('',timeEnd-timeStart)
  } catch (error) {
    console.log(error)
  }
}

// 执行ECLP外单包裹标签普通打印
export const executeECLPExternalOrderPackageTagCommonPrint = async (obCheckM, label, printSeq) => {
  try {
    console.log("执行ECLP外单包裹标签普通打印:" + label.faceOrderAddress);
    let timeBegin = new Date().getTime();
    // $("#faceSheetImg" + printSeq).attr('src',"data:image/png;base64," + faceImage);
    // $("#printFaaceSheetImgButton" + printSeq).click();
    // await printByImgType(faceImage,printSeq, obCheckM.outboundNo)
    let imgType = judgeImgType(label.faceOrderAddress)
    console.log("executeECLPExternalOrderPackageTagCommonPrint 方法图片类型:" + imgType);
    //如果base64为空  或者 类型为pdf的 即使有base64也得传地址
    if(_.isEmpty(label.face) || 'pdf' == imgType || 'html' == imgType){
      console.log("pdf 打印重新转 base64")
      await printByImgType(label.faceOrderAddress, printSeq, obCheckM.outboundNo)
    } else if('zpl' == imgType) {
      // 执行zpl打印逻辑
      await printZPL(label.faceOrderAddress, obCheckM.outboundNo)
    } else {
      await printByImgType(label.face, printSeq, obCheckM.outboundNo, label.faceOrderAddress)
    }
    let timeEnd = new Date().getTime();
    console.log("执行ECLP外单包裹标签普通打印耗时（" + obCheckM.outboundNo + "）：" + (timeEnd - timeBegin) + "毫秒！");
    commonAddLog('PaperlessPackageTag.js$executeECLPExternalOrderPackageTagCommonPrint()',obCheckM.outboundNo,`复核---执行ECLP外单包裹标签普通打印耗时：${(timeEnd - timeBegin)} faceOrderAddress: ${label.faceOrderAddress}`, {cost: timeEnd - timeBegin})
  } catch (error) {
    console.log("执行ECLP外单包裹标签普通打印报错：" + error);
  }
}

// 执行ECLP外单包裹标签打印
export const executeECLPExternalOrderPackageTagPrint = async (obCheckM, faceImage,faceOrderAddress, isSavePackage) => {
  try {
    console.log("单包裹打印:" + faceImage);
    let imgType = judgeImgType(faceOrderAddress)
    console.log("executeECLPExternalOrderPackageTagPrint 方法图片类型:" + imgType);
    //如果base64为空  或者 类型为pdf的 即使有base64也得传地址 autoPacking为绑定打包机的不需要系统打印面单
    if(!obCheckM.autoPacking){
      if(null == faceImage || '' == faceImage || 'pdf' == imgType || 'html' == imgType){
        console.log("pdf 打印重新转 base64")
        await printByImgType(faceOrderAddress, '', obCheckM.outboundNo)
      } else if('zpl' == imgType) {
        // 执行zpl打印逻辑
        await printZPL(faceOrderAddress, obCheckM.outboundNo)
      } else {
        await printByImgType(faceImage, '', obCheckM.outboundNo,faceOrderAddress)
      }
    }
    printEnd(true)
    console.log("executeECLPExternalOrderPackageTagPrint 是否要保存包裹号:" + isSavePackage);
    commonAddLog('setPackageTrackingNo',obCheckM.outboundNo,`执行ECLP外单 是否要保存包裹号： ${isSavePackage}`, {cost: 0})
    if(isSavePackage){
      commonAddLog('setPackageTrackingNo',obCheckM.outboundNo,`执行ECLP外单 setPackageTrackingNo 开始 ${new Date()}`, {cost: 0})
      let trackingNoRes = await shipmentService.setPackageTrackingNo(obCheckM)
      try {
        commonAddLog('setPackageTrackingNo',obCheckM.outboundNo,`执行ECLP外单 setPackageTrackingNo 结束 ${new Date()}, 返回值：${JSON.stringify(trackingNoRes)}`, {cost: 0})
      } catch (e) {}
    }
  } catch (error) {
    if(isSavePackage){
      commonAddLog('setPackageTrackingNo',obCheckM.outboundNo,`catch内执行ECLP外单 setPackageTrackingNo 开始 ${new Date()}`, {cost: 0})
      await shipmentService.setPackageTrackingNo(obCheckM)
      commonAddLog('setPackageTrackingNo',obCheckM.outboundNo,`catch内执行ECLP外单 setPackageTrackingNo 结束 ${new Date()}`, {cost: 0})
    }
    commonAddLog('executeECLPExternalOrderPackageTagPrint_catch',obCheckM.outboundNo,`执行ECLP外单包裹标签打印报错： ${JSON.stringify(error)}`, {cost: 0})
    console.log("执行ECLP外单包裹标签打印报错：" + error);
  }
}

// 执行3PL包裹标签打印
export const executePaperlessPackageTag3PLPrint = async (obCheckM, packageList, extMap, param, alreadyPrintAdr = false) => {
    // 1.调用3PL接口，获取面单信息
  let call3PLResult
  try {
    scReport('请求3pl打单老接口', 'start');
    call3PLResult = await get3plFaceInfo(packageList, obCheckM, extMap)
    scReport('请求3pl打单老接口', 'end');
  } catch (e) {
    printEnd(true)
    console.log("call单失败",e)
    if(+obCheckM.hkmCallFailHandleType != 1){
      customizeNotifyWithVoice(NOTIFY_TYPE_ENUM.error, i18n.t('call3PLInterfaceFailure'))
    }else{
      customizeNotifyWithVoice(NOTIFY_TYPE_ENUM.warning, i18n.t('call3PLInterfaceFailure'))
    }
  }
  console.log("获取3PL面单结果：" + JSON.stringify(call3PLResult))
    if(call3PLResult && !_.isEmpty(call3PLResult.labels) && call3PLResult.labels.length>200) {
      if(obCheckM.labelType === 3){
        //组装打印call单失败的替换页
        let callFailedInfo = {}
        callFailedInfo.outboundNo = obCheckM.outboundNo;
        callFailedInfo.packageNo = packageList[0].packageNo;
        callFailedInfo.ownerNo = obCheckM.ownerNo;
        if(callFailedInfo.packageNo == null || callFailedInfo.packageNo ==='undefined' || callFailedInfo.packageNo ===''){
          callFailedInfo.packageNo = obCheckM.outboundNo;
        }
        callFailedInfo.errorMassage = "Print exception! Printing failed due to over 200 waybills";
        //执行打印call单失败的替换页
        await printCallLabelFailedReplaceTab(callFailedInfo)
      }
      // hkm订单
      if(+obCheckM.hkmCallFailHandleType != 1){
        $notify.error(i18n.t('collectTaskPrintError'));
      }else{
        $notify.warning(i18n.t('collectTaskPrintError'));
      }
    }

    // 2.如果下单接口返回是异步面单，执行下面逻辑
    if (call3PLResult && call3PLResult.isAsync && call3PLResult.isAsync === 1) {
      console.log("paperlessPackageTag.js:异步面单，执行异步逻辑")
      return call3PLResult
    }

    // 3.打面单
    await printLabel(obCheckM, param, call3PLResult)

    // 危险品参数组装&打印adr
    console.log('调用get3plFaceInfo获取面单打面单后组装adr信息buildParamsAndPrintAdr==========>>>')
    console.log('调用get3plFaceInfo获取面单打面单后组装adr信息buildParamsAndPrintAdr==========>>>param', param)
    console.log('调用get3plFaceInfo获取面单打面单后组装adr信息buildParamsAndPrintAdr==========>>>call3PLResult', call3PLResult)
    console.log('调用get3plFaceInfo获取面单打面单后组装adr信息buildParamsAndPrintAdr==========>>>obCheckM', obCheckM)
    // 打印adr -- 多包裹明细中有危险品和带电净重才去调用
    if(param && param.listPackagingD && !_.isEmpty(param.listPackagingD) && !alreadyPrintAdr){
      let printAdrByEDISwitch = 0
      const isExistUnCode = param.listPackagingD.find(item => item.unCode && item.outboundNo === obCheckM.outboundNo)
      const isExistBatteryNetWeight = param.listPackagingD.find(item => item.batteryNetWeight && item.outboundNo === obCheckM.outboundNo)
      const needPrintAdrLabel = isExistUnCode && isExistBatteryNetWeight
      if (needPrintAdrLabel) {
        // 危险品标签提示
        showUnCodeLabelDialog(param.listPackagingD)
        printAdrByEDISwitch = await getSysConfigByKey('PrintAdrImdg_ByEDI_Switch')
        const isNewPrintMethod = +printAdrByEDISwitch === 1
        if (isNewPrintMethod && obCheckM.printAdrImdgFlag === 1) {
          const printParams = await getPrintAdrFileInfo({listPackageD: param.listPackagingD})
          if (!_.isEmpty(printParams)) {
            obCheckM.specifiedTemplate = printParams.isPrintFile ? 1 : 0
            obCheckM.adrTemplateCode = printParams.templateCode
          }
        } else {
          obCheckM.specifiedTemplate = 0
        }
        commonAddLog('多包裹明细危险品参数组装&打印adr',obCheckM.outboundNo,`参数校验---执行打印前：isExistUnCode=${isExistUnCode} isExistBatteryNetWeight=${isExistBatteryNetWeight}`)
        console.log('多包裹isExistUnCode', isExistUnCode)
        console.log('多包裹isExistBatteryNetWeight', isExistBatteryNetWeight)
        if (!isNewPrintMethod || obCheckM.specifiedTemplate === 1) {
          await buildParamsAndPrintAdr(call3PLResult, obCheckM, param)
        }
      }
    }
    return call3PLResult;
}

// 危险品打印adr
export const buildParamsAndPrintAdrByOne = async (obCheckM, params) => {
  // 批量调用3pl新打单接口获取adr面单
  // resultList取运单号
  // params取危险品编码
  // 危险品编码、运单号
  const printParams = {
    ...params,
    printMethod: printConst.PRINT_METHOD.Onetime,
    packageCount: 1
  }
  let startTime = new Date().getTime()
  console.log('单包裹===========================>>>>>>>>>>>')
  let paramResult = makePrintParams(obCheckM, printParams)
  let endTime = new Date().getTime()
  cutoutLogAndReporting('paperlessPackageTag.js.buildParamsAndPrintAdrByOne-makePrintParams',obCheckM.outboundNo, paramResult, endTime - startTime)
  SgmPrintMonitor('call3plAPi_url_3pl_platForm_dangerous_one_package_makePrintParams', endTime - startTime, paramResult)
  let startReqTime = new Date().getTime()
  const adrResult = await getFaceByCall3pl(paramResult)
  let endResTime = new Date().getTime()
  cutoutLogAndReporting('paperlessPackageTag.js.buildParamsAndPrintAdrByOne-getFaceByCall3pl',obCheckM.outboundNo, {adrResult, params}, endResTime - startReqTime)
  SgmPrintMonitor('call3plAPi_url_3pl_platForm_dangerous_one_package', endResTime - startReqTime, adrResult)
  // 执行adr打印
  let startPrintTime = new Date().getTime()
  // 指定模版场景默认打印3份
  const printNum = obCheckM.specifiedTemplate === 1 ? 3 : 1
  await executePrint(adrResult, obCheckM.outboundNo, printNum)
  let endPrintTime = new Date().getTime()
  cutoutLogAndReporting('paperlessPackageTag.js.buildParamsAndPrintAdrByOne-executePrint',obCheckM.outboundNo, adrResult, endPrintTime - startPrintTime)
  SgmPrintMonitor('call3plAPi_url_3pl_platForm_dangerous_one_package_executePrint', endPrintTime - startPrintTime, adrResult)
}

// 危险品打印adr
export const buildParamsAndPrintAdr = async (resultList, obCheckM, params) => {
  // 批量调用3pl新打单接口获取adr面单
  // resultList取运单号
  // params取危险品编码
  // 危险品编码、运单号
  let startTime = new Date().getTime()
  console.log('多包裹===========================>>>>>>>>>>>')
  let paramResult = makePrintParams(obCheckM, params, resultList)
  let endTime = new Date().getTime()
  cutoutLogAndReporting('paperlessPackageTag.js.buildParamsAndPrintAdr-makePrintParams',obCheckM.outboundNo, paramResult, endTime - startTime)
  SgmPrintMonitor('call3plAPi_url_3pl_platForm_dangerous_package_makePrintParams', endTime - startTime, paramResult)
  let startReqTime = new Date().getTime()
  console.log('paramResult111', paramResult);
  const adrResult = await getFaceByCall3pl(paramResult)
  let endResTime = new Date().getTime()
  cutoutLogAndReporting('paperlessPackageTag.js.buildParamsAndPrintAdr-getFaceByCall3pl',obCheckM.outboundNo, {adrResult, params}, endResTime - startReqTime)
  SgmPrintMonitor('call3plAPi_url_3pl_platForm_dangerous_package', endResTime - startReqTime, adrResult)
  // 执行adr打印
  let startPrintTime = new Date().getTime()
  // 指定模版场景默认打印3份
  const printNum = obCheckM.specifiedTemplate === 1 ? 3 : 1
  await executePrint(adrResult, obCheckM.outboundNo, printNum)
  let endPrintTime = new Date().getTime()
  cutoutLogAndReporting('paperlessPackageTag.js.buildParamsAndPrintAdr-executePrint',obCheckM.outboundNo, adrResult, endPrintTime - startPrintTime)
  SgmPrintMonitor('call3plAPi_url_3pl_platForm_dangerous_package_executePrint', endPrintTime - startPrintTime, adrResult)
}

/**
 * 调用3pl获取面单信息
 * @param {*} params
 */
const getFaceByCall3pl = async (params) => {
  try {
    console.log('危险品打印adr调用打单平台新接口获取面单入参为:' + JSON.stringify(params))
    cutoutLogAndReporting('危险品打印adr调用打单平台新接口入参', params.outboundNo, params)
    let startTime = new Date().getTime()
    // let result = await shipmentService.call3plPlatformNew(params)
    let result = await shipmentService.getDangerousPrintPlatform(params)
    let endTime = new Date().getTime()
    console.log('危险品打印adr调用打单平台新接口获取面单出参为:' + JSON.stringify(result))
    console.log('危险品打印adr调用打单平台新接口获取面单耗时:' + (endTime - startTime) + '毫秒')
    cutoutLogAndReporting('危险品打印adr调用打单平台新接口出参', params.outboundNo, result, endTime - startTime)
    if (result && result.code === 0 && result.data.length > 0) {
      return result
    } else {
      // 因为存配置了调用新接口，不需要打印的情况，如果3PL返回成功，则不报异常
      if (result.code !== 0) {
        // $notify.warning(i18n.t(result.msg))
        $notify.warning(i18n.t('callBillingCenterExcept',[result.msg]))
      } else {
        $notify.warning(i18n.t('3PL did not return relevant documents, please contact 3PL!'))
      }
      return null
    }
  } catch (error) {
    console.error('调用打单平台新接口获取面单异常：' + error)
    $notify.warning(i18n.t('callPrintPlatformFailureRemark', [error]))
  }
}

const cutoutLogAndReporting = (bizName, bizKey, logInfo, time = 0, maxLength = 3000, cutoutLength = 80) => {
  try {
    let logStrInfo = JSON.stringify(logInfo)
    if(logStrInfo && logStrInfo.length > maxLength){
      logStrInfo = logStrInfo.substring(0, cutoutLength)
    }
    commonAddLog(bizName, bizKey, `上报结果：${logStrInfo}, 耗时：${time}`)
  } catch (error) {
    console.log(error)
  }
}

/**
 * 执行打印
 * @param {*} adrResult
 * @param {*} outboundNo
 * @param {*} printNum
 */
const executePrint = async (adrResult, outboundNo, printNum = 1) => {
  if(!adrResult || (adrResult && adrResult.data && adrResult.data.length <= 0)){
    console.log('执行adr打印adrDataList无数据')
    return
  }

  cutoutLogAndReporting('executePrint执行adr打印',outboundNo, adrResult)

  const printDataList = adrResult.data
  try {
    let startTime = new Date().getTime()
    for (let i = 0; i < printDataList.length; i++) {
      let data = printDataList[i]
      if (data.docResults.length > 0) {
        for (let a = 0; a < data.docResults.length; a++) {
          let label = data.docResults[a]
          // A4尺寸采用云打印打印面单
          if (data.size === '210*297' || (data.docType === '6' && !data.size)) {
            let content = {}
            content.templateId = 10 // A4通用模板
            let data = {}
            content.data = data
            data.picture = label
            await print(content,printNum)
          } else if (data.size === '297*210') {
            // 横板A4通用模板
            let content = {}
            content.templateId = 101
            let data = {}
            content.data = data
            data.picture = label
            await print(content,printNum)
          } else if (data.size === '100*150' || data.size === '150*100') {
            // 普通面单采用浏览器打印
            let faceInfo = await shipmentService.getFaceInfo({outboundNo: outboundNo});
            setFaceSheetStyle(!_.isEmpty(faceInfo) ? faceInfo.faceSize : '');
            printByImgType(label)
          } else {
            console.error('The label return from 3PL missing size info,please contact 3PL!')
            $notify.warning(i18n.t('The label return from 3PL missing size info,please contact 3PL!'))
          }
        }
      }
    }
    let endTime = new Date().getTime()
    cutoutLogAndReporting('executePrint执行adr打印完成',outboundNo, printDataList, endTime - startTime)
  } catch (error) {
    console.log(error)
  }
}

/**
 * 打印参数校验
 * @param printParam
 */
const checkNewPrintParam = (printParam) => {
  if (_.isEmpty(printParam)) return
  // 如果是一次性打单包裹数量必须为正整数
  if (printConst.PRINT_METHOD.Onetime === printParam.printMethod) {
    if (!(/(^[1-9]\d*$)/.test(printParam.packageCount))) {
      $notify.error(i18n.t('packageNumMustBeInteger'))
    }
  }
  // 如果是按包裹分多次打单包裹序号必须为正整数
  if (printConst.PRINT_METHOD.Multiple === printParam.printMethod) {
    if (!(/(^[1-9]\d*$)/.test(printParam.packageSqueue))) {
      $notify.error(i18n.t('inputErrMustBePositiveInteger'))
    }
  }
}

/**
 * 封装包裹维度入参
 * @param ObCheckMR
 * @param packageParamInfoList
 */
export const createPackageParamInfoList = (ObCheckMR, packageParamInfoList) => {
  // 封装packageParamInfo（只处理包裹号）
  // 每个包裹的平均重量
  let perWeight = (ObCheckMR.totalWeight / ObCheckMR.listPackageM.length).toFixed(2)
  for (let pm of ObCheckMR.listPackageM) {
    let packageParamInfo = packageParamInfoList.find(t => (t.packageId === pm.packageNo))
    if (_.isEmpty(packageParamInfo)) {
      let packageParam = {
        packageId: pm.packageNo,
        requiredData: {
          packedDate: formatDateTime(new Date()),
          totalWeight: perWeight,
          sscc: pm.sscc
        }
      }
      packageParamInfoList.push(packageParam)
    }
  }
  // 有明细数据则封装包裹里的商品信息
  if (!_.isEmpty(ObCheckMR.listPackageD)) {
    for(let pd of ObCheckMR.listPackageD) {
      for (let packageParamInfo of packageParamInfoList) {
        if(pd.packageNo === packageParamInfo.packageId) {
          let skus = []
          if(_.isEmpty(packageParamInfo.requiredData)) {
            let goodsInfo = {
              goodsCode: pd.goodsNo,
              qty: pd.checkQty,
              weight: pd.goodsWeight * pd.checkQty,
              serialNos: pd.scanCode
            }
            skus.push(goodsInfo)
            packageParamInfo.requiredData.totalWeight = 0
          } else {
            let goodsInfo = {}
            skus = packageParamInfo.requiredData.skus
            if (!_.isEmpty(skus)) {
              for (let hadGoodsInfo of skus) {
                if (hadGoodsInfo.goodsCode === pd.goodsNo) {
                  goodsInfo = hadGoodsInfo
                  hadGoodsInfo.qty += pd.checkQty
                  hadGoodsInfo.weight += pd.goodsWeight * pd.checkQty
                  if (pd.serialStart && pd.serialEnd) {
                    hadGoodsInfo.serialNos += ',' + pd.serialStart + '-to-' + pd.serialEnd
                  } else {
                    hadGoodsInfo.serialNos += ',' + pd.scanCode
                  }
                  break
                }
              }
            } else {
              skus = []
              // 没有该商品的信息 则新增
              if (_.isEmpty(goodsInfo)) {
                let goodsInfo = {
                  goodsCode: pd.goodsNo,
                  qty: pd.checkQty,
                  weight: pd.goodsWeight * pd.checkQty,
                  serialNos: pd.scanCode
                }
                skus.push(goodsInfo)
              }
            }
          }
          packageParamInfo.requiredData.totalWeight += pd.goodsWeight * pd.checkQty
          packageParamInfo.requiredData.skus = skus
        }
      }
    }
  }

  // 将requiredData中的数据转为字符串
  for (let packageParamInfo of packageParamInfoList) {
    packageParamInfo.requiredData = JSON.stringify(packageParamInfo.requiredData)
  }
}

/**
 *
 * @param ObCheckMR
 * @param printParam
 */
export const createPackageInfoList = (ObCheckMR, printParam, call3plResultList) => {
  console.log('createPackageInfoList-printParam', printParam)
  let packageParamInfoList = []
  // 如果是补打
  if (printParam.resetPrint === 1) {
    if (_.isEmpty(ObCheckMR.listPackageM)) {
      $notify.error(i18n.t('noPackageDataConfirmFinish'))
    }
    createPackageParamInfoList(ObCheckMR, packageParamInfoList)
  } else {
    // 如果是一次性打单 包裹号统一生成
    if (printConst.PRINT_METHOD.Onetime === printParam.printMethod) {
      console.log('printParam-Onetime', printParam)
      for (let i = 0; i < printParam.packageCount; i++) {
        let packageParamInfo = createPackageParamInfo(ObCheckMR, printParam)
        packageParamInfoList.push(packageParamInfo)
      }
    }

    if (printConst.PRINT_METHOD.Multiple === printParam.printMethod) {
      console.log('printParam-Multiple', printParam)
      let packageNoList = []
      const packageNoListMap = {}
      if (call3plResultList && !_.isEmpty(call3plResultList.labels)) {
        packageNoList = call3plResultList.labels.map(packageD => packageD.packageID)
        // 包含对应包裹号的
        packageNoList.forEach(packageNo => {
          packageNoListMap[packageNo] = []
        })

        for (let i = 0; i < packageNoList.length; i++) {
          let packageNo = packageNoList[i]
          let packageParamInfo = createPackageParamInfoByMultiple(ObCheckMR, printParam, call3plResultList, packageNo)
          console.log('packageParamInfo2', packageParamInfo);
          // 必须是adr危险品
          if (packageParamInfo && packageParamInfo.packageId) {
            packageParamInfoList.push(packageParamInfo)
          }
        }
      }
    }
  }

  return packageParamInfoList
}

/**
 * 封装包裹维度入参实体类
 * @param ObCheckMR
 */
const createPackageParamInfo = (ObCheckMR, printParam) => {
  console.log('createPackageParamInfo')
  let packageParamInfo = {}
  packageParamInfo.packageId = ''
  let requiredData = {
    packedDate: formatDateTime(new Date()),
    totalWeight: 0,
    skus: [],
    sscc: null,
    // 运单号
    // trackingNumber: ObCheckMR.trackingNo,
    shipNo: ObCheckMR.trackingNo,
  }
  // 有明细数据则封装包裹里的商品信息
  if (!_.isEmpty(printParam.listPackagingD)) {
    let goodsInfos = []
    for(let pd of printParam.listPackagingD) {
      if(ObCheckMR.outboundNo === pd.outboundNo || ObCheckMR.checkNo === pd.outboundNo){
        let goodsInfo = {
          goodsCode: pd.goodsNo,
          qty: pd.checkQty,
          weight: pd.goodsWeight * pd.checkQty,
          serialNos: pd.scanCode,
          // 危险品编码，多个用","逗号分隔
          unCodes: pd.unCode,
          electricWeight: pd.batteryNetWeight || null
        }
        goodsInfo.weight = Number(goodsInfo.weight.toFixed(2))
        if (pd.serialStart && pd.serialEnd) {
          goodsInfo.serialNos += ',' + pd.serialStart + '-to-' + pd.serialEnd
        }
        packageParamInfo.packageId = pd.packageNo
        goodsInfos.push(goodsInfo)
      }
    }
    requiredData.skus = goodsInfos
  }
  packageParamInfo.requiredData = JSON.stringify(requiredData)
  // SgmPrintMonitor('adr_one_package_createPackageParamInfo_obCheckMR_log', 0, ObCheckMR)
  // SgmPrintMonitor('adr_one_package_createPackageParamInfo_printParam_log', 0, printParam)
  // SgmPrintMonitor('adr_one_package_createPackageParamInfo_packageParamInfo_log', 0, packageParamInfo)
  return packageParamInfo
}

/**
 * 封装包裹维度入参实体类
 * @param ObCheckMR
 * @param printParam
 * @param call3plResultList
 */
const createPackageParamInfoByMultiple = (ObCheckMR, printParam, call3plResultList, packageNo) => {
  console.log('createPackageParamInfoByMultiple')
  let packageParamInfo = {}
  packageParamInfo.packageId = ''
  const requiredData = {
    packedDate: formatDateTime(new Date()),
    totalWeight: ObCheckMR.totalWeight,
    skus: [],
    sscc: null,
    // 运单号
    // trackingNumber: '',
    shipNo: ''
  }
  // 有明细数据则封装包裹里的商品信息
  if (!_.isEmpty(printParam.listPackagingD)) {
    let goodsInfos = []
    // 是否多包裹统一call
    const isMultiPackageCallSheetFlag = ObCheckMR.multiPackageCallSheetFlag === 1
    console.log('isMultiPackageCallSheetFlag', isMultiPackageCallSheetFlag)
    for(let pd of printParam.listPackagingD) {
      // 必须是危险品 unCode,batteryNetWeight 有值
      if(packageNo === pd.packageNo && pd.unCode && pd.batteryNetWeight){
        let goodsInfo = {
          goodsCode: pd.goodsNo,
          qty: pd.checkQty,
          weight: pd.goodsWeight * pd.checkQty,
          serialNos: pd.scanCode,
          // 危险品编码，多个用","逗号分隔
          unCodes: pd.unCode,
          electricWeight: pd.batteryNetWeight || null
        }
        goodsInfo.weight = Number(goodsInfo.weight.toFixed(2))
        if (pd.serialStart && pd.serialEnd) {
          goodsInfo.serialNos += ',' + pd.serialStart + '-to-' + pd.serialEnd
        }
        packageParamInfo.packageId = pd.packageNo
        if(call3plResultList && call3plResultList.labels && call3plResultList.labels.length){
          const sameTrackingInfo = call3plResultList.labels.find(item => item.packageID === pd.packageNo)
          if(sameTrackingInfo){
            requiredData.shipNo = sameTrackingInfo.trackingNumber
          }
        }
        goodsInfos.push(goodsInfo)
      }
    }
    requiredData.skus = goodsInfos
  }
  packageParamInfo.requiredData = JSON.stringify(requiredData)
  // SgmPrintMonitor('adr_packages_createPackageParamInfo_packageNo_log', 0, packageNo)
  // SgmPrintMonitor('adr_packages_createPackageParamInfo_printParam_log', 0, printParam)
  // SgmPrintMonitor('adr_packages_createPackageParamInfo_obCheckMR_log', 0, ObCheckMR)
  // SgmPrintMonitor('adr_packages_createPackageParamInfo_call3plResultList_log', 0, call3plResultList)
  // SgmPrintMonitor('adr_packages_createPackageParamInfo_packageParamInfo_log', 0, packageParamInfo)
  console.log('packageParamInfo', packageParamInfo);
  return packageParamInfo
}

// 按包裹组装参数
const makePrintParams = (ObCheckMR, printParam, call3plResultList) => {
  checkNewPrintParam(printParam)
  let checkM = ObCheckMR
  let param = {}
  param.docId = checkM.outboundNo
  param.orderId = checkM.outboundNo
  param.source = 'WMS'
  param.resDocType = 1 // 1外部链接 2Base64字符串
  param.resDocFormat = 'PNG'
  param.sppCode = checkM.carrierNo // 服务商产品
  param.outboundNo = checkM.outboundNo
  if (ObCheckMR.isRepairPrint !== undefined && ObCheckMR.isRepairPrint !== null && ObCheckMR.isRepairPrint === 1) {
    param.resetPrint = 1 // 补打
    if (!_.isEmpty(printParam)) {
      printParam.resetPrint = 1 // 补打
    }
  }
  // 包裹维度
  param.printDimension = 2
  // 复核一包裹call一次，多包裹多次call
  printParam.printMethod = printParam.printMethod || printConst.PRINT_METHOD.Multiple
  console.log('makePrintParams=> printParam', printParam)
  // 封装包裹维度信息
  let packageParamInfoList = []
  // 复核一单一包裹call一次
  // 复核一单多包裹一次call
  packageParamInfoList = createPackageInfoList(ObCheckMR, printParam, call3plResultList)
  param.packageParamInfoList = packageParamInfoList
  param.resDocType = 1 // 1外部链接 2Base64字符串
  param.outboundNo = checkM.outboundNo
  param.excludePrintDocType = printParam.excludePrintDocType // 显式指定不打印的单据 具体单据类型参考接口文档
  param.docType = printParam.docType || '11' // 显式指定打印的单据 具体单据类型参考接口文档 危险品打印adr：11
  param.originOrderId = checkM.fkId
  if (+checkM.specifiedTemplate === 1) {
    param.templateCode = checkM.adrTemplateCode
  }
  return param
}

/**
 * 打面单
 *
 * */
const printLabel = async (obCheckM, param, resultList) => {
  try {
    // 1.打印面单
    let obCheckMR = {};
    obCheckMR.listPackageM = [];
    let timeBegin = new Date().getTime();
    if(!_.isEmpty(resultList) && !_.isEmpty(resultList.labels)){
      for (let i = 0; i < resultList.labels.length; i++) {
        let obPackageM = {};
        obPackageM.checkShipNo = resultList.labels[i].trackingNumber;
        obPackageM.outboundNo = obCheckM.outboundNo;
        obPackageM.orgNo = obCheckM.orgNo;
        obPackageM.distributeNo = obCheckM.distributeNo;
        obPackageM.warehouseNo = obCheckM.warehouseNo;
        obPackageM.packageNo = resultList.labels[i].packageID;
        obPackageM.reverseShipNo = obCheckM.reverseShipNo
        obPackageM.dangerousFlag = resultList.labels[i].dangerousFlag;
        obPackageM.unScore = resultList.labels[i].unScore;

        // 匹配waybillNoList里的waybillNo 通过 packageId匹配
        obPackageM.jdwWaybillCode = matchWaybillNo(obPackageM.packageNo, resultList.waybillNoList)
        obPackageM.reverseJdwWaybillCode = matchReverseWaybillNo(obPackageM.packageNo, resultList.waybillNoList)

        obCheckMR.listPackageM.push(obPackageM);
        // 如果要打印的是逆向面单，判断fop下发的不打逆向面单标识
        if (resultList.labels[i].labelKind == labelKindFor3pl.RETURNED && obCheckM.printReverseFlag == 1) {
          console.info("订单号：" + obCheckM.outboundNo + ", fop打标不打印逆向面单");
          continue
        }
        if(!_.isEmpty(resultList.labels[i].images)) {
          for (let j = 0; j < resultList.labels[i].images.length; j++) {
            // 如果打印了shippingpaper，就不在调用原有浏览器打印
            let flag = await shippingPaperRepeatPrint(resultList.labels[i],obCheckM)
            if(!flag){
              // 具体逻辑这里处理
              console.log('原有逻辑浏览器打印 url：' + resultList.labels[i].images[j]);
              await printByImgType(resultList.labels[i].images[j],i, obCheckM.outboundNo, null, resultList.labels[i].imageType)
            }
          }
        }
      }

      // 判断是否保存3PL逆向运单号
      let flag = await check3PLReversePrint(resultList, obCheckM)
      if(flag){
        // 赋值3PL逆向运单号
        await initReversePackageM(resultList, obCheckMR)
        console.log('执行3PL打印逆向运单：' + JSON.stringify(obCheckMR.listPackageM));
      }
    }
    console.log("🚀 ~ printLabel ~ obCheckMR:", obCheckMR)
    let timeEnd = new Date().getTime();
    console.log('执行3PL包裹标签打印耗时（' + obCheckM.outboundNo + '）：' + (timeEnd - timeBegin) + '毫秒！');
    commonAddLog('PaperlessPackageTag.js$executePaperlessPackageTag3PLPrint()',obCheckM.outboundNo,`复核---执行3PL包裹标签打印耗时：${(timeEnd - timeBegin)}`, {cost: timeEnd - timeBegin})

    // 打印3pl返回的包裹维度发票
    if (!_.isEmpty(resultList) && !_.isEmpty(resultList.attachLabels)) {
      for (let invoiceLabel of resultList.attachLabels) {
        if (invoiceLabel.labelKind !== labelKindFor3pl.INVOICE || _.isEmpty(invoiceLabel.images)) {
          continue
        }
        for (let image of invoiceLabel.images) {
          await executeInvoicePrint(image);
        }
      }
    }
    // 2.保存或者更新包裹信息
    // 需要带着运单号保存包裹信息的
    console.log('param:...' + JSON.stringify(param))
    if(!_.isEmpty(param) && !param.isSaveWithoutShipNo){
      obCheckMR.listPackageM.forEach(packM=>{
        param.listPackageM.forEach(pm=>{
          if(packM.outboundNo==pm.outboundNo && packM.packageNo == pm.packageNo){
            pm.checkShipNo = packM.checkShipNo
            pm.reverseShipNo = packM.reverseShipNo
            pm.dangerousFlag = packM.dangerousFlag
            pm.unScore = packM.unScore
            // 赋值jdwNo
            pm.jdwWaybillCode = packM.jdwWaybillCode
          }
        })
      })
      if(param.obCheckMR.notCommitCustomer202 && param.obCheckMR.notCommitCustomer202 == true){
        param.obCheckMR.listPackageM = param.listPackageM
      }else {
        try {
          this.$addLog('paperlessPackageTag addOrderPackage', '小黄人上报202', {
            outboundNo: obheckM?.outboundNo,
          })
        } catch (e) {
          console.error('rechecking $addLog error', e)
        }
        await addOrderPackage(param);
      }
    }else{
      console.log('param  obCheckMR:...' + JSON.stringify(obCheckMR))
      // 需要更新3PL运单号的
      let startTimeSave = new Date().getTime();
      let result = await shipmentService.savePackageTagFor3PL(obCheckMR)
      let endTimeSave = new Date().getTime();
      console.log("保存运单数据:" + (endTimeSave-startTimeSave) + "毫秒");
      if (!result){
        // $notify.error(i18n.t('saveShipNoFailure'));
        customizeNotifyWithVoice(NOTIFY_TYPE_ENUM.error, i18n.t('saveShipNoFailure'))
        return;
      }
    }
    // 打印3pl返回的非面单单据
    if (!_.isEmpty(resultList) && !_.isEmpty(resultList.labelImage)) {
      await printByImgType(resultList.labelImage, '', obCheckM.outboundNo)
    }
  } catch (error) {
    console.log('执行3PL包裹标签打印报错：' + error);
    // $notify.error(i18n.t('saveShipNoFailure'));
    customizeNotifyWithVoice(NOTIFY_TYPE_ENUM.error, i18n.t('saveShipNoFailure'))
  }
}

// 请求3pl获取异步面单并打印
export const print3plAsyncLabel = async (obCheckM, asyncLabelResult, param) => {
    // 1.调用3PL接口，获取面单信息
    // 250428，该接口切换成仓的接口，不走3pl了
    let call3PLResult= await get3plAsyncLabel(asyncLabelResult, obCheckM);
    let callFailedInfo = {}
    try {
      //组装打印call单失败的替换页
      callFailedInfo.outboundNo = obCheckM.outboundNo;
      callFailedInfo.ownerNo = obCheckM.ownerNo;
      // callFailedInfo.packageNo = asyncLabelResult[0].packageID
      callFailedInfo.packageNo = _.isEmpty(asyncLabelResult.labels) ? null : asyncLabelResult.labels[0].packageID
      if(callFailedInfo.packageNo == null || callFailedInfo.packageNo ==='' || callFailedInfo.packageNo ==='undefined'){
        callFailedInfo.packageNo = obCheckM.outboundNo;
      }
    } catch (e) {
      console.log(e);
    }
    // 产品要求，后台接口轮询不展示请求成功失败提示
    if (!(call3PLResult && call3PLResult.status === 2)) {
      // $notify.warning(i18n.t('call3PLAsyncLabelFailureRemark', [result.remark]));
      // 在异步面单失败的时候不打印call单失败替换页
      // if(obCheckM.labelType === 3){
      //   callFailedInfo.errorMassage = "Failed to call 3PL async label interface to obtain face sheet information，Remark：" + call3PLResult.remark;
      //   //执行打印call单失败的替换页
      //   await printCallLabelFailedReplaceTab(callFailedInfo)
      // }
      return;
    } else {
      console.log("请求异步面单成功，清除循环定时器")
      clearInterval(window.asyncLabelTimer)
      // $notify.success(i18n.t('call3PLAsyncLabelSuccess', [result.remark]));
    }
    if(call3PLResult.labels.length>200) {
      if(obCheckM.labelType === 3){
        callFailedInfo.errorMassage = "Print exception! Printing failed due to over 200 waybills";
        //执行打印call单失败的替换页
        await printCallLabelFailedReplaceTab(callFailedInfo)
      }
      $notify.error(i18n.t('collectTaskPrintError'));
      return;
    }

    // 2.打印异步面单
    // 设置面单尺寸
    let faceInfo = await shipmentService.getFaceInfo({outboundNo: obCheckM.outboundNo});
    let size = !_.isEmpty(faceInfo) ? faceInfo.faceSize : null
    setFaceSheetStyle(size);
    // 打面单
    printLabel(obCheckM, param, call3PLResult)

    return call3PLResult
}

export const hiddenTelephone = (oldTelephone, isHidePhone) => {
  if (!oldTelephone) {
    return "";
  }

  if (isHidePhone === 0) {
    return oldTelephone
  }

  let tels = _.replace(oldTelephone, " ", "").split(',');
  let newTels = "";
  for (const tel of tels) {
    if (tel.length < 7)
    {
      newTels += tel + ",";
    } else {
      newTels += tel.substr(0, 3) + "^_^" + tel.substr(tel.length - 4, 4) + ",";
    }
  }
  return newTels.substr(0, newTels.length - 1);
}
export const setFaceSheetStyle = (faceSize) => {
  console.log("面单尺寸配置:" + faceSize);
  //设置面单尺寸
  let faceSizeStr = faceSize;
  let generalFaceSize = {"width":"370px","height":"550px"};
  if(typeof(faceSizeStr) != "undefined" && faceSizeStr != "" && faceSizeStr !=null) {
    let faceSizeArray =  faceSizeStr && faceSizeStr.split(",");
    let selfFaceSize = {};
    if(faceSizeArray.length > 1) {
      let width = faceSizeArray[0];
      let height = faceSizeArray[1];
      if(typeof(width) != "undefined" && width != "") {
        selfFaceSize.width = width;
      }
      if(typeof(height) != "undefined" && height != "") {
        selfFaceSize.height = height;
      }
      $(".faceSheetImgCss").css(selfFaceSize);
    } else {
      $(".faceSheetImgCss").css(generalFaceSize);
    }
  } else {
    $(".faceSheetImgCss").css(generalFaceSize);
  }
}

export const webPrintImg = (base64, seq) => {
  if(typeof (base64) == "undefined" || base64 =="") {
    return;
  }
  let sequence = 0;
  if(seq){
    sequence = seq;
  }
  $("#faceSheetImg" + sequence).attr('src',"data:image/png;base64," + base64);
  $("#printFaaceSheetImgButton" + sequence).click();
}

/**
 * 判断图片格式
 * @param {*} imgInfo 图片链接或者名字
 * @returns
 */
 export const judgeImgType = (imgInfo) => {
   let imgType = null
  if(/\.(png)(\?.*)?/i.test(imgInfo)){
    imgType = "png"
  }
  if(/\.(pdf)(\?.*)?/i.test(imgInfo)){
    imgType = "pdf"
  }
  if(/\.(html)(\?.*)?/i.test(imgInfo)){
    imgType = "html"
  }
  if(/\.(zpl)(\?.*)?/i.test(imgInfo)){
    imgType = "zpl"
  }
  console.info("图片格式为：" + imgType)
  return imgType
}
const ABILITIES_CLOUD_PRINT = 'outbound_printSheet_cloudPrint_flag'


/**
 *
 * @param {*} imgInfo
 * @param {*} printSeq
 */
export const printByImgType = async (imgInfo, printSeq = '', outboundNo = '',faceOrderAddress, imageType) => {
  console.log("🚀 ~ printByImgType ~ faceOrderAddress:", faceOrderAddress, imageType)
  let imgType = judgeImgType(imgInfo)
  console.log('imgType:', imgType)
  let faceSheetCloudPrintFlag
  if (window.sessionStorage.getItem('enable_facesheet_cloud_print') !== null) {
    faceSheetCloudPrintFlag = window.sessionStorage.getItem('enable_facesheet_cloud_print') == '1';
  } else {
    let enableFacesheetCloudPrint = await getSysConfigByKey('enable_facesheet_cloud_print');
    faceSheetCloudPrintFlag = enableFacesheetCloudPrint == '1';
    window.sessionStorage.setItem('enable_facesheet_cloud_print', enableFacesheetCloudPrint);
  }
  let currentCloudPrintFlag = window.localStorage.getItem(userInfo.userCode + '_currentCloudPrintFlag') === '1'
  commonAddLog('printFlag ',outboundNo,`云打印开关 faceSheetCloudPrintFlag: ${faceSheetCloudPrintFlag} currentCloudPrintFlag: ${currentCloudPrintFlag}`)
  // png格式的base64码打印无法控制尺寸 所以采用$("#faceSheetImg")形式打印
  if('png' == imgType || 'PNG' == imgType){
    let timeConSta = new Date().getTime();
    let result = await convertBase64(imgInfo);
    let timeConEnd = new Date().getTime();
    console.log("获取面单convertBase64转换打印耗时：" + (timeConEnd - timeConSta));
    commonAddLog('PaperlessPackageTag.js$printByImgType()',outboundNo,`复核---获取面单convertBase64转换打印耗时：${(timeConEnd - timeConSta)} faceSheetCloudPrintFlag || currentCloudPrintFlag: ${faceSheetCloudPrintFlag || currentCloudPrintFlag} ${faceSheetCloudPrintFlag} ${currentCloudPrintFlag}`, {cost: timeConEnd - timeConSta})
    commonAddLog('PaperlessPackageTag.js$printByImgType-browserPrint_PNG_convertBase64',outboundNo,`获取面单耗时：${(timeConEnd - timeConSta)}  faceOrderAddress：${faceOrderAddress}`, {cost: timeConEnd - timeConSta})
    SgmPrintMonitor('browserPrint_PNG_convertBase64', timeConEnd - timeConSta, {imgInfo})
    if (faceSheetCloudPrintFlag || currentCloudPrintFlag) {
      const startTime=new Date().getTime()
      commonAddLog('cloudPrintLog',outboundNo, `PNG云打印 仓编码：${Cookies.get('warehouseNo')} 复核台：${window.localStorage.getItem('strPlatformNo')} su打包复核台：${window.localStorage.getItem('strPlatformNoNew')}`)
      // 检查imgInfo是否为一个有效的URL
      if (imgInfo.includes('storage.ochama.com')) {
        // 替换域名
        imgInfo = imgInfo.replace('storage.ochama.com', 'storage-cdn.ochama.com');
      }
      await cloudPrintUrl(imgInfo)
      const endTime=new Date().getTime()
      // printPointEnd('cloudPrint2',endTime-startTime,startTime)
    } else {
      const startTime=new Date().getTime()
      $("#faceSheetImg" + printSeq).attr('src',"data:image/png;base64," + result.url);
      $("#printFaaceSheetImgButton" + printSeq).click();
      const endTime=new Date().getTime()
      printPointEnd('localPrint',startTime)
    }
    let timeEnd = new Date().getTime();
    commonAddLog('PaperlessPackageTag.js$printByImgType-browserPrint_PNG_print',outboundNo,`打印耗时：${(timeEnd - timeConEnd)}`, {cost: timeEnd - timeConEnd})
    commonAddLog('PaperlessPackageTag.js$printByImgType-browserPrint_PNG_convertBase64AndPrint',outboundNo,`总耗时：${(timeEnd - timeConSta)}`, {cost: timeEnd - timeConSta})
    SgmPrintMonitor('browserPrint_PNG_print', timeEnd - timeConEnd, {imgInfo})
    SgmPrintMonitor('browserPrint_PNG_convertBase64AndPrint', timeEnd - timeConSta, {imgInfo})
  } else if ('pdf' == imgType){
    console.log("面单pdf convertBase64转换打印");
    let timeConSta = new Date().getTime();
    let result = await convertBase64(imgInfo);
    let timeConEnd = new Date().getTime();
    commonAddLog('PaperlessPackageTag.js$printByImgType-browserPrint_PDF_convertBase64',outboundNo,`总耗时：${(timeConEnd - timeConSta)}`, {cost: timeConEnd - timeConSta})
    SgmPrintMonitor('browserPrint_PDF_convertBase64', timeConEnd - timeConSta, {imgInfo})
    //获取系统参数，是否开启PDF面单走云打印
    // 缓存系统参数
    let pdfCloudPrintFlag;
    if (window.sessionStorage.getItem('enable_pdf_facesheet_cloud_print') !== null) {
      pdfCloudPrintFlag = window.sessionStorage.getItem('enable_pdf_facesheet_cloud_print');
    } else {
      pdfCloudPrintFlag = await getSysConfigByKey('enable_pdf_facesheet_cloud_print');
      window.sessionStorage.setItem('enable_pdf_facesheet_cloud_print', pdfCloudPrintFlag);
    }
    console.log('开启PDF面单走云打印系统参数配置值为：' + pdfCloudPrintFlag + "（0：不开启；1：开启）")
    //pdf走云打印，调用统一的PDF打印方法封装数据
    if ((pdfCloudPrintFlag !== null && pdfCloudPrintFlag !=='' &&
      pdfCloudPrintFlag !== undefined && pdfCloudPrintFlag == 1) || currentCloudPrintFlag) {
      let timeStart = new Date().getTime();
      commonAddLog('cloudPrintLog',outboundNo, `PDF云打印 仓编码：${Cookies.get('warehouseNo')} 复核台：${window.localStorage.getItem('strPlatformNo')} su打包复核台：${window.localStorage.getItem('strPlatformNoNew')}`)
      cloudPrintPDF(result, imgInfo);
      let timeEnd = new Date().getTime();
      commonAddLog('PaperlessPackageTag.js$printByImgType-cloudPrint_PDF_print', outboundNo, `打印耗时：${(timeEnd - timeStart)}`, { cost: timeEnd - timeStart })
      commonAddLog('PaperlessPackageTag.js$printByImgType-cloudPrint_PDF_convertBase64AndPrint', outboundNo, `总耗时：${(timeEnd - timeConSta)}`, { cost: timeEnd - timeConSta })
      SgmPrintMonitor('cloudPrint_PDF_print', timeEnd - timeStart, { imgInfo })
      SgmPrintMonitor('cloudPrint_PDF_convertBase64AndPrint', timeEnd - timeConSta, { imgInfo })
    }else{
        return new Promise((resolve, reject) => {
          let timeStart = new Date().getTime();
          printJS({ printable: result.url, type: 'pdf', base64: true, onPrintDialogClose: resolve });
          let timeEnd = new Date().getTime();
          printPointEnd('printJS',timeStart)
          printEnd(true)
          commonAddLog('PaperlessPackageTag.js$printByImgType-browserPrint_PDF_print', outboundNo, `打印耗时：${(timeEnd - timeStart)}`, { cost: timeEnd - timeStart })
          commonAddLog('PaperlessPackageTag.js$printByImgType-browserPrint_PDF_convertBase64AndPrint', outboundNo, `总耗时：${(timeEnd - timeConSta)}`, { cost: timeEnd - timeConSta })
          SgmPrintMonitor('browserPrint_PDF_print', timeEnd - timeStart, { imgInfo })
          SgmPrintMonitor('browserPrint_PDF_convertBase64AndPrint', timeEnd - timeConSta, { imgInfo })
        })
      }
  } else if ('html' == imgType){
    let timeStart = new Date().getTime();
    await printHTML(imgInfo);
    let timeEnd = new Date().getTime();
    commonAddLog('PaperlessPackageTag.js$printByImgType-browserPrint_HTML_print',outboundNo,`总耗时：${(timeEnd - timeStart)}`, {cost: timeEnd - timeStart})
    SgmPrintMonitor('browserPrint_HTML_print', timeEnd - timeStart, {imgInfo})
  } else if ('zpl' == imgType){
    // 执行zpl打印逻辑
    let timeStart = new Date().getTime();
    await printZPL(imgInfo, outboundNo)
    let timeEnd = new Date().getTime();
    commonAddLog('PaperlessPackageTag.js$printByImgType-browserPrint_ZPL_print',outboundNo,`总耗时：${(timeEnd - timeStart)}`, {cost: timeEnd - timeStart})
    SgmPrintMonitor('browserPrint_ZPL_print', timeEnd - timeStart, {imgInfo})
  } else { // 默认imgInfo为png格式的base64码
    // 兼容base64串和url链接
    let timeStart = new Date().getTime();

    // $("#faceSheetImg" + printSeq).attr('src', imgInfo);
    // $("#printFaaceSheetImgButton" + printSeq).click();
    // if (faceSheetCloudPrintFlag || currentCloudPrintFlag) {
    //   await cloudPrintBase64(imgInfo)
    // } else {
    //   imgInfo = imgInfo.startsWith('http') ? imgInfo : `data:image/png;base64,${imgInfo}`
    //   const timeStart=new Date().getTime()
    //   $("#faceSheetImg" + printSeq).attr('src', imgInfo);
    //   $("#printFaaceSheetImgButton" + printSeq).click();
    //   const timeEnd=new Date().getTime()
    //   printPointEnd('localPrint',timeStart)
    // }
    if (faceSheetCloudPrintFlag || currentCloudPrintFlag) {
      if (imageType?.toUpperCase() === 'PDF') {
        await cloudPrintPDF({url: imgInfo}, imgInfo);
      } else {
        await cloudPrintBase64(imgInfo);
      }
    } else {
      if (imageType?.toUpperCase() === 'PDF') {
        return new Promise((resolve, reject) => {
          printJS({ printable: imgInfo, type: 'pdf', base64: true, onPrintDialogClose: resolve });
        });
      } else {
        $("#faceSheetImg" + printSeq).attr('src', imgInfo.startsWith('http') ? imgInfo : `data:image/png;base64,${imgInfo}`);
        $("#printFaaceSheetImgButton" + printSeq).click();
        printPointEnd('localPrint',timeStart)
      }
    }
    let timeEnd = new Date().getTime();
    commonAddLog('PaperlessPackageTag.js$printByImgType-browserPrint_base64AndUrl_print',outboundNo,`总耗时：${(timeEnd - timeStart)}`, {cost: timeEnd - timeStart})
    SgmPrintMonitor('browserPrint_base64AndUrl_print', timeEnd - timeStart, {imgInfo})
  }
  // printEnd(true,'printByImg')
  console.log("开始调用打印预览....");
}
/**
 *
 * @param {*} imgInfo html资源地址
 */
export const printHTML = async (imgInfo) => {
  const startTime=new Date().getTime()
  let url = `${getPrefix().outboundApi}/check/img/getImgHtml?printUrl=` + encodeURIComponent(imgInfo);
  fetch(url)
    .then(response=>response.blob())
    .then(json=>{
      const src=window.URL.createObjectURL(json);
      const iframe=document.createElement('iframe');
      iframe.src=src;
      iframe.style.display='none';
      document.body.appendChild(iframe);
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      printPointEnd(
        'localPrint',
        startTime
      )
    }).catch(err=>{
      console.log('RequestFailed',err)
      printPointEnd(
        'localPrint',
        startTime,
        {
          eptCustMessage:'html打印错误：'+err
        }
      )
    });
}


/**
 * 云打印打印PDF
 * @param printNum 打印份数
 * */
export const cloudPrintPDF = async (result,labelUrl) => {
    console.log("已开启PDF面单走云打印,开始组装模板参数...");
    if(result && result.url){
      let base64Code = result.url
      // 组装参数
      let content = {}
      //pdf_facesheet.cpt,模板设置为100宽*150高，此模板尺寸不影响PDF文件的打印尺寸，只作为调用打印调用云打印的传输介质
      //随便一个云打印模板都可以，只是为了代码中好区分，且不影响其他使用中的模板，所以用此新模板来传输
      content.templateId = 45
      content.printPDF = 1
      content.pdfSrc = base64Code
      let data = {}
      content.data = data
      data.picture = labelUrl
      console.log("PDF文件云打印参数组装完成，开始执行打印,content:" + JSON.stringify(content))
      // 云打印
      await print(content)
    }
}

/**
 * 云打印打印Base64
 * @param printNum 打印份数
 * */
export const cloudPrintBase64 = async (labelUrl) => {
  console.log("已开启PDF面单走云打印,开始组装模板参数...");
  // 组装参数
  let content = {}
  content.templateId = 68
  //content.printPDF = 1
  // content.pdfSrc = labelUrl
  let data = {}
  content.data = data
  data.picture = labelUrl
  console.log("PNG文件云打印参数组装完成，开始执行打印,content:" + JSON.stringify(content))
  // 云打印
  await print(content)
}

/**
 * 云打印打印Url
 * @param printNum 打印份数
 * */
export const cloudPrintUrl = async (labelUrl) => {
  console.log("已开启PDF面单走云打印,开始组装模板参数...");
  // 组装参数
  let content = {}
  //pdf_facesheet.cpt,模板设置为100宽*150高，此模板尺寸不影响PDF文件的打印尺寸，只作为调用打印调用云打印的传输介质
  //随便一个云打印模板都可以，只是为了代码中好区分，且不影响其他使用中的模板，所以用此新模板来传输
  content.templateId = 58
  //content.printPDF = 1
  // content.pdfSrc = labelUrl
  let data = {}
  content.data = data
  data.picture = labelUrl
  console.log("PNG文件云打印参数组装完成，开始执行打印,content:" + JSON.stringify(content))
  // 云打印
  await print(content)
}

export const formateCallFailedReplaceTabParamsAndPrint = async (packageList, printParam, failedReason) => {
  try {
    // 组装打印call单失败的替换页
    let callFailedInfo = {}
    callFailedInfo.outboundNo = printParam ? printParam.outboundNo : '';
    callFailedInfo.ownerNo = printParam ? printParam.ownerNo : '';
    callFailedInfo.packageNo = packageList && packageList[0] ? (packageList[0].packageNo || packageList[0].packageID) : '';
    callFailedInfo.errorMassage = failedReason || i18n.t('call3PLInterfaceFailure')
    await printCallLabelFailedReplaceTab(callFailedInfo)
  } catch (error) {
    console.log(error)
  }
}
// 打印正向面单
export const print3plFaceInfo = async (packageList, printParam) => {
  let resultList = null;
  try {
    resultList = await get3plFaceInfo(packageList,printParam)
  } catch {
    $notify.error(i18n.t('call3PLInterfaceFailure'));
    return;
  }
  if (!resultList) {
    $notify.error(i18n.t('call3PLInterfaceFailure'));
    return;
  }
  if (_.isEmpty(resultList.labels)) {
    $notify.error(i18n.t('call3PLInterfaceFailureRemark', [resultList.remark]));
    return;
  }
  let faceInfo = await shipmentService.getFaceInfo({outboundNo: printParam.outboundNo});
  setFaceSheetStyle(faceInfo.faceSize);
  let shipInfos = []
  for (let i = 0; i < resultList.labels.length; i++) {
    let shipInfo = {};
    shipInfo.checkShipNo = resultList.labels[i].trackingNumber;
    shipInfo.packageNo = resultList.labels[i].packageID; // 大包裹号
    shipInfos.push(shipInfo);
    if(!_.isEmpty(resultList.labels[i].images)) {
      for (let j = 0; j < resultList.labels[i].images.length; j++) {
        await printByImgType(resultList.labels[i].images[j],i, printParam.outboundNo)
        // collectLabelInfo({type: waybillTypeMapping[0], size: faceInfo.faceSize});
      }
    }
  }
  return shipInfos
}
/**
 * 获取逆向面单信息
 * @param {*} curObCheckMR
 * @param {*} consumable 耗材信息
 */
// HKM逆向面单各目的国默认承运商编码映射(数据字典) sessionStorage 缓存 key
const HKM_REVERSE_CARRIER_CACHE_KEY = 'HKM_DEFAULT_REVERSE_CARRIERNO_MAP';

/**
 * 获取 HKM 逆向面单各目的国默认承运商编码映射(数据字典)
 * 结果转成 { 国家code: 承运商编码 } 映射，并使用 sessionStorage 缓存，避免重复请求
 * @returns {Promise<Object>} { 国家code: 承运商编码 }
 */
export const getHkmReverseCarrierMap = async () => {
  // 始终优先拉取后端接口，成功则刷新缓存并返回；接口报错时再用 sessionStorage 缓存兜底
  try {
    const hkmReverseCarrierDic = await qryDicDetailByCode('HKM_DEFAULT_REVERSE_CARRIERNO', userInfo);
    const map = (hkmReverseCarrierDic || []).reduce((acc, item) => {
      acc[item.code] = item.value;
      return acc;
    }, {});
    // 刷新缓存
    try {
      window.sessionStorage.setItem(HKM_REVERSE_CARRIER_CACHE_KEY, JSON.stringify(map));
    } catch (cacheErr) {
      console.warn('写入HKM逆向承运商字典缓存失败', cacheErr);
    }
    return map;
  } catch (e) {
    console.error('获取HKM逆向承运商字典失败，尝试使用缓存兜底', e);
    // 接口报错时用缓存顶替
    try {
      const cache = window.sessionStorage.getItem(HKM_REVERSE_CARRIER_CACHE_KEY);
      if (cache) {
        return JSON.parse(cache);
      }
    } catch (cacheErr) {
      console.warn('读取HKM逆向承运商字典缓存失败', cacheErr);
    }
    return {};
  }
};

export const getReverseInfo = async(checkM,receiveAndSenderInfo, consumable = {}, packageM = {}, listPackageD = [], carrierNoObj) => {
  // 若调用方未传入 carrierNoObj，则内部获取字典映射（带 sessionStorage 缓存），兼容老的调用方式
  if (!carrierNoObj) {
    carrierNoObj = await getHkmReverseCarrierMap();
  }
  // 获取逆向面单时包裹信息不重要
  let packageList = [];
  let p = {};
  p.packageID = checkM.outboundNo+'#Reverse-1-';
  p.weight = packageM.weight || 1
  p.length = packageM.length || 1
  p.width = packageM.width || 1
  p.height = packageM.height || 1
  if(Array.isArray(listPackageD) && listPackageD.length > 0) {
    p.goods = []
    listPackageD.forEach((packageD) => {
      let good={}
      good.claimValue = packageD.price;
      good.currency = packageD.currency;
      good.hsCode = packageD.hsCode;
      good.sourceCountry = packageD.sourceCountry;
  
      good.goodsCount = packageD.checkQty
      good.goodsNo =  packageD.goodsNo
      good.goodsCode =  packageD.goodsNo
      good.goodsName =  packageD.goodsName
      good.unCode = packageD.unCode
      good.goodsBarcode = packageD.goodsBarcode
      if (good.unCode && good.unCode !== '') {
        good.goodsWeightUnits = packageD.weightUnit
        good.goodsWeight = packageD.batteryNetWeight
        good.batteryCapacity = packageD.batteryCapacity
        good.capacityUnit = packageD.capacityUnit
      }else{
        good.goodsWeightUnits = packageD.weightUnit
        good.goodsWeight = packageD.weight
      }
      p.goods.push(good)
    })
  }
  packageList.push(p);
  let param = {}
  param.orgNo = checkM.orgNo
  param.distributeNo = checkM.distributeNo
  param.warehouseNo = checkM.warehouseNo
  // HKM逆向面单：根据收货地址目的国，用数据字典配置的默认承运商编码调用3PL call单
  if (checkM.receiverCountry && carrierNoObj) {
    param.carrierNo =  carrierNoObj[checkM.receiverCountry]  || checkM.carrierNo
  } else {
    param.carrierNo = checkM.carrierNo
  }
  param.returnShipment=true
  param.fullLabel=true //仓库下单
  param.labelRetType = 2 // 以url格式返回
  param.receiver=receiveAndSenderInfo.receiver
  param.sender=receiveAndSenderInfo.sender
  param.outboundNo = checkM.outboundNo
  param.salesPlatformOrder = checkM.salesPlatformOrder
  param.orderLocal = checkM.orderLocal
  param.jdwWaybillCode = checkM.jdwWaybillCode
  param.jdwNewFaceFlag = checkM.jdwNewFaceFlag
  param.scanCon = consumable;
  console.info("获取逆向面单入参："+ JSON.stringify(param))
  try {
    let resultList = await get3plFaceInfo(packageList, param)
    if (!resultList) {
      if(+checkM.hkmCallFailHandleType != 1){
        $notify.error(i18n.t('call3PLInterfaceFailure'));
      }else{
        $notify.warning(i18n.t('call3PLInterfaceFailure'));
      }
      return;
    }
    if (_.isEmpty(resultList.labels)) {
      if(+checkM.hkmCallFailHandleType != 1){
        $notify.error(i18n.t('call3PLInterfaceFailureRemark', [resultList.remark]));
      }else{
        $notify.warning(i18n.t('call3PLInterfaceFailureRemark', [resultList.remark]));
      }

      return;
    }
    // 逆向面单 一个订单只会有一张
    let reverseInfo = {}
    reverseInfo.reverseShipNo = resultList.labels[0].trackingNumber
    reverseInfo.reverseUrl =  resultList.labels[0].images[0]
    return reverseInfo
  } catch (e) {
    console.error('逆向面单打印异常',e)
    if(+checkM.hkmCallFailHandleType != 1){
      $notify.error(i18n.t('call3PLInterfaceFailure'));
    }else{
      $notify.warning(i18n.t('call3PLInterfaceFailure'));
    }
    return
  }
}

export const isPrintZplBySystemParams = async () =>  {
  const res = await getSystemConfig({key:'print_zpl'})
  return res ? 'zpl' : 'png'
}
/**
 * 3pl获取正逆向面单信息 有些业务也叫包裹面单
 * @param {*} packageList 包裹集合
 * @param {*} printParam 一些必须参数的承载
 *            printParam.returnShipment  是否逆向面单
 *            printParam.taskNo 门店打包的唯一标识，其他场景暂不需要
 * @param {*} extMap 长度和重量单位
 * @returns
 */
export const get3plFaceInfo = async (packageList, printParam, extMap) => {
  console.log('get3plFaceInfo', packageList);
  // 1、请求3pl下单接口，拼接入参
  let model = {};
  if(printParam.taskNo){
    model.orderId = printParam.taskNo
  } else if(packageList && packageList.length > 0){
    let arr = packageList[0].packageID.split('-');
    model.orderId = arr[0];
  }
  model.packageCount = packageList.length;
  model.packages = packageList;
  if(printParam.returnShipment && printParam.returnShipment == true){
    model.returnShipment = true
  } else {
    model.returnShipment = false
  }
  model.optionType = printParam.rePackaged ? 'RE_PACKAGE' : 'FIRST_PACKAGE';
  if (model.optionType === "FIRST_PACKAGE" && printParam.isRepairPrint !== null && printParam.isRepairPrint === 1) {
    model.optionType = "RE_PRINT";
  }
  try{
    commonAddLog('[RE_PRINT排查]', printParam.outboundNo, JSON.stringify({
      outboundNo: printParam.outboundNo,
      isRepairPrint: printParam.isRepairPrint,
      typeofIsRepairPrint: typeof printParam.isRepairPrint,
      rePackaged: printParam.rePackaged,
      resetPrint: printParam.resetPrint,
      optionTypeBefore: model.optionType,
    }));
  }catch(e){
    console.log(e)
  }
  // 最后一个包裹标识 针对包裹明细采集的场景  非包裹明细采集、重打包和补打都不用传
  if(printParam.fullPackageFinish && printParam.fullPackageFinish === true){
    model.lastOfBatch = printParam.fullPackageFinish;
  }
  if(printParam.fullLabel){
    model.expressCompId = printParam.carrierNo
    model.source = "WMS-FULL"
    model.optionType = "TRY_PRINT_FIRST_PACKAGE" // TRY_PRINT_FIRST_PACKAGE -> 3pl的判断逻辑为：如果已经下单则查询，否则下单
    model.optionType = printParam.rePackaged ? 'RE_PACKAGE' : "TRY_PRINT_FIRST_PACKAGE";
  }else {
    model.source = "WMS"
    model.expressCompId = printParam.siteNo
  }
  model.labelStockType = null;
  model.imageType = null;
  model.weightUnits = null;
  model.dimensionsUnits = null;
  console.log("extMap:" + JSON.stringify(extMap));
  if (typeof (extMap) !== 'undefined' && extMap != null && extMap !== '') {
    model.weightUnits = extMap.weightUnit;
    model.dimensionsUnits = extMap.dimensionsUnit;
  }
  // 多包裹zpl打印暂时注释根据系统参数来调整请求3pl的imageType参数
  // const printTypeBySys = await isPrintZplBySystemParams()
  // model.imageType =  printTypeBySys || "PNG";
  model.imageType =  "PNG";
  if(printParam.labelRetType){
    model.labelRetType=printParam.labelRetType
  }else{
    model.labelRetType = 1;
  }
  if(printParam.splitByPackage){
    model.packageDimension = 1; // 按包裹拆单标识
    model.forceSinglePackage = printParam.forceSinglePackage ? 1 : 0;
  }
  model.weight = 0;
  model.sourceNodeCode = null;
  if(printParam.receiver){
    model.receiver = printParam.receiver
  } else {
    // 设置国家和站点标识
    paperlessPackageTagHelper.setCountryAndSiteFlag(model, printParam);
  }
  if(printParam.sender){
    model.sender = printParam.sender
  }
  model.thrOrderId = printParam.salesPlatformOrder
  // 透传订单下的贸易条款字段(tradeClause)
  model.internationalOptions = {
    termsOfShipment: printParam.tradeClause
  }
  // 2、请求3pl下单接口，发起调用，记录日志
  // 获取认证权限码
  model.authorization = paperlessPackageTagHelper.getAuthorizationCode(model.orderId);
  model.salePlat = printParam.orderLocal;
  // 耗材编码, 若不具备耗材采集能力，则默认值为''
  const consumableCode = _.isEmpty(printParam.scanCon) ? '' : printParam.scanCon.conCode;
  model.packages.map(p => {
    p.consumableCode = consumableCode;
    return p
  })
  // JDW单号改造 jdw单号回传以及第一个包裹打标
  const isJDWNoRemouldSysFlag = await isJDWNoRemouldSys(printParam)
  if (isJDWNoRemouldSysFlag) {
    model = JDWNoRemouldParams(model, printParam)
  }
  model.outboundNo = printParam.outboundNo;
  console.log("调用3PL接口请求参数:" + JSON.stringify(model));
  commonAddLog('PaperlessPackageTag.js$get3plFaceInfo()-request',printParam.outboundNo ? printParam.outboundNo : 'get3plFaceInfo',`调用3PL接口请求参数：${JSON.stringify(model)}`)
  SgmPrintMonitor('call3plAPi_url_3pl_request', 0, model)
  let startTime1 = new Date().getTime();
  let result = {};
  if (printParam.forwardAndReverse && isJDWNoRemouldSysFlag) {
    const param = {
      partialSuccess: false,
      waybillList: [
        model,
        {...model, orderNo: printParam.reverseJdwWaybillCode, jdwWaybillCode: printParam.reverseJdwWaybillCode}
      ]
    }
    result = await shipmentService.batchGetLabelsForJDW(param);
    console.log(JSON.parse(JSON.stringify(result)), '正逆一体场景请求3pl返回值---->')
  } else {
    result = isJDWNoRemouldSysFlag ? await shipmentService.get3PLFaceNew(model) : await shipmentService.get3PLFace(model);
  }
  // 重构返回结果数据结构 兼容老逻辑
  if (isJDWNoRemouldSysFlag) {
    // 调用结果 1 - 调用成功 0 - 调用异常
    let resultNew = {
      ...result,
      ...result.data,
    }
    result = {...resultNew}
  }
  let endime1 = new Date().getTime();
  console.log("调用3pl接口耗时:" + (endime1 - startTime1) + "毫秒");
  console.info("调用青龙3PL接口返回结果：" + JSON.stringify(result));
  Add3PLResponseLog(printParam.outboundNo ? printParam.outboundNo : 'get3plFaceInfo', endime1 - startTime1, model, result);
  commonAddLog('PaperlessPackageTag.js.get3plFaceInfo-call3plAPi_url_3pl',printParam.outboundNo ? printParam.outboundNo : 'get3plFaceInfo',`总耗时：${endime1 - startTime1}`, {cost: endime1 - startTime1})
  SgmPrintMonitor('call3plAPi_url_3pl', endime1 - startTime1, result)
  //组装打印call单失败的替换页
  let callFailedInfo = {}
  callFailedInfo.outboundNo = printParam.outboundNo;
  callFailedInfo.ownerNo = printParam.ownerNo;
  if(packageList && packageList.length > 0){
    // let arr = packageList[0].packageID.split('-');
    // if((callFailedInfo.outboundNo).trim() == ''){
    // }
    callFailedInfo.packageNo = packageList[0].packageID
  }else{
    callFailedInfo.pareceiverckageNo = printParam.outboundNo;
  }
  // 3、请求3pl下单接口，出参校验
  // 返回空的情况（3pl服务重启/超时）
  if(!result || _.isEmpty(result)) {
    SgmMonitor.printCustomMonitor({
      code: 'SGM_custom_api_url_3pl_url_3pl_new',
      msg: {
        desc: 'get3plFaceInfo获取面单get3PLFaceNew/get3PLFace失败-返回空的情况（3pl服务重启/超时）',
        result
      }
    })
    // if(printParam.labelType === 3){
      callFailedInfo.errorMassage = "Calling 3pl to obtain the package waybill failed with an empty return";
      // 超时记录失败信息到包裹表
      await saveCallFailResult(packageList, printParam, callFailedInfo.errorMassage)

      //执行打印call单失败的替换页
      await printCallLabelFailedReplaceTab(callFailedInfo)
    //}
    if(+printParam.hkmCallFailHandleType != 1){
      throw new Error("get 3pl face label fail ~");
      // customizeNotifyWithVoice(NOTIFY_TYPE_ENUM.error, i18n.t('call3PLInterfaceFailure'))
    }else{
      customizeNotifyWithVoice(NOTIFY_TYPE_ENUM.warning, i18n.t('call3PLInterfaceFailure'))
    }

    return
  }
  // 返回了，但是status不是2(成功状态)，或者没有面单信息
  if ((isJDWNoRemouldSysFlag ? result.callState !== 1 : result.status !== 2) || _.isEmpty(result.labels)) {
    SgmMonitor.printCustomMonitor({
      code: 'SGM_custom_api_url_3pl_url_3pl_new',
      msg: {
        desc: 'get3plFaceInfo获取面单get3PLFaceNew/get3PLFace失败-返回空的情况（3pl服务重启/超时）',
        result
      }
    })
    // if(printParam.labelType === 3) {
    callFailedInfo.errorMassage = "Calling the 3PL interface to obtain waybill information failed, note:" + result.remark;
    if(callFailedInfo.errorMassage > 200){
      callFailedInfo.errorMassage = callFailedInfo.errorMassage.substring(0,200)
    }
    await saveCallFailResult(packageList, printParam, callFailedInfo.errorMassage)
    //执行打印call单失败的替换页
    await printCallLabelFailedReplaceTab(callFailedInfo)
    //}
    if(+printParam.hkmCallFailHandleType != 1){
      throw new Error("get 3pl face label fail ~");
      // customizeNotifyWithVoice(NOTIFY_TYPE_ENUM.error, i18n.t('call3PLInterfaceFailureRemark', [result.remark]))
    }else{
      customizeNotifyWithVoice(NOTIFY_TYPE_ENUM.warning, i18n.t('call3PLInterfaceFailureRemark', [result.remark]))
    }
    return
  }
  // 如果是异步面单，返回结果中把包裹信息带上（再次发起异步面单请求需要用到包裹信息）
  if (result.isAsync === 1) {
    result.packageCount = packageList.length;
    result.packages = packageList;
  }
  return result
}

/**
 * 3pl获取异步面单
 */
export const get3plAsyncLabel = async (asyncLabelResult, obCheckM) => {
  let model = {};
  model.orderId = asyncLabelResult.orderId
  model.packageCount = asyncLabelResult.packageCount;
  model.packages = asyncLabelResult.packages.map(item => {
    // 新增 item.packageNo，兼容重打包逻辑
    return {
      packageID: item.packageID || item.packageNo
    }
  });

  model.source = "WMS"
  model.imageType = "PNG";
  model.labelRetType = 1;
  // 获取认证权限码
  model.authorization = paperlessPackageTagHelper.getAuthorizationCode(model.orderId);
  let startTime1 = new Date().getTime();
  SgmPrintMonitor('call3plAPi_url_3pl_async_label_request', 0, model)
  // 250428，不走3pl的接口了
  // let result = await shipmentService.get3plAsyncLabel(model);
  // 走仓的接口
  console.log("调用3PL异步面单接口请求参数:" + JSON.stringify(model));
  let result = await asyncLabel(model);
  let endime1 = new Date().getTime();
  console.log("调用3PL异步面单接口请求参数:" + JSON.stringify(model));
  console.log("调用3pl异步面单接口耗时:" + (endime1 - startTime1) + "毫秒");
  commonAddLog('PaperlessPackageTag.js$get3plAsyncLabel()',obCheckM.outboundNo,`复核---调用3pl异步面单接口获取面单信息耗时：${(endime1 - startTime1)}`, {cost: endime1 - startTime1})
  commonAddLog('PaperlessPackageTag.js.get3plAsyncLabel-call3plAPi_url_3pl_async_label',obCheckM.outboundNo,`总耗时：${endime1 - startTime1}`, {cost: endime1 - startTime1})
  SgmPrintMonitor('call3plAPi_url_3pl_async_label', endime1 - startTime1, result)
  console.info("调用3PL异步面单接口返回结果：" + JSON.stringify(result));
  return result;
}


/**
 * 添加订单包裹信息
 * @param param
 * @returns {null}
 */
 export const addOrderPackage = async (param) => {
  let obCheckMR = param.obCheckMR;
  obCheckMR.listConsumable = param.listConsumable;
  obCheckMR.listPackageM = param.listPackageM;
  obCheckMR.ListPackageD = param.listPackageD;
  obCheckMR.opUser = getOpuser(param.packingOrder);

  // 汇总包裹明细数据
  if (obCheckMR.listPackageD) {
    fillPackagegD(obCheckMR);
  }
  let timeBegin = new Date().getTime();
  try {
    this.$addLog('paperlessPackageTag addOrderPackage2', '小黄人上报202开始', {
      obCheckMR: obCheckMR,
    })
  } catch (e) {
    console.error('rechecking $addLog error', e)
  }
  const res = await shipmentService.addOrderPackage(obCheckMR);
  try {
    this.$addLog('paperlessPackageTag addOrderPackage2', '小黄人上报202结束', {
      outboundNo: obCheckMR?.checkM?.outboundNo,
      res: res,
    })
  } catch (e) {
    console.error('rechecking $addLog error', e)
  }
  try {
    const parseRes = JSON.parse(res);
    parseRes.wallFinished && customizeNotifyWithVoice(NOTIFY_TYPE_ENUM.success, i18n.t('wallComplete'));
  } catch {}
  let timeEnd = new Date().getTime();
  console.log("添加打包结果耗时：" + (timeEnd - timeBegin));
  const outboundNo = param.packingOrder && param.packingOrder.outboundNo ? param.packingOrder.outboundNo : ''
  commonAddLog('PaperlessPackageTag.js$addOrderPackage()',outboundNo,`复核---添加打包结果耗时：${(timeEnd - timeBegin)}`, {cost: timeEnd - timeBegin})
}


export const getOpuser = (packingOrder) => {
  let opUser = {}
  opUser.userCode = userInfo.userCode;
  opUser.userName = userInfo.userName;
  opUser.userAccount = userInfo.userAccount;
  opUser.checkLine = "0";
  opUser.platformNo = packingOrder.platformNo;
  return opUser;
}

/**
 * 填充打包明细数据
 * @param obCheckMR
 * @returns {null}
 */
 export const fillPackagegD = (obCheckMR) => {
  for (const packageM of obCheckMR.listPackageM) {
    let flag = false;
    for (const packageD of obCheckMR.listPackageD) {
      if (packageD.packageOrder == packageM.packageOrder) {
        packageD.packageNo = packageM.packageNo;
        flag = true;
      }
    }
    if (!flag) {
      $notify.error(i18n.t('packageDetailNotBeNull'));
      break;
    }
  }
}

/**
 * 保存日志
 * @param bizName 页面路由
 * @param bizKey 方法名称
 * @param content 日志内容
 * @param cost 耗时毫秒数 单纯日志上报传0
 * @param alerm 是否触发ump自定义报警
 * @param env 所属环境 hl,xjp,不能是汉字
 */
export const commonAddLog =  (bizName,bizKey, content, monitorInfo = {}) => {
  const {alerm = false, env = 'deafult', cost = 0} = monitorInfo
  const logParam = {
    alerm,
    env,
    cost
  }
  logParam.bizType='outbound'
  logParam.bizName=bizName
  logParam.bizKey=bizKey || 'default'
  logParam.content=content
  logParam.createUser = userInfo.userCode
  try {
    addLog(logParam);
  }catch (e){
    console.error("addlog异常，不影响业务，不做处理")
  }
}

export const batchSubBase64 = (base64List) => {
  if(!Array.isArray(base64List)) return base64List;
  let base64ListNew = JSON.parse(JSON.stringify(base64List));
  return base64ListNew.map(item => {
    if(item && typeof item === 'string' && item.length > 0){
      return item.substring(0,50);
    }
    return item;
  })
}

export const Add3PLResponseLog = (outboundNo, requestTime, request, response) => {
  try {
    // 直接用=赋值是浅拷贝
    let res = JSON.parse(JSON.stringify(response))
    if (res && res.labels && res.labels.length > 0) {
      res.labels.forEach(label => {
        if (label && label.images && label.images.length > 0) {
          let len = label.images.length;
          for (let i = 0; i < len; i++) {
            label.images[i] = label.images[i].substring(0,50)
          }
        }
      })
    }
    // 这个埋点不要动，志刚（看板）那边有统计成功率
    let logParam = {}
    logParam.bizType = 'outbound'
    logParam.bizName = 'PaperlessPackageTag.js$get3plFaceInfo()'
    logParam.bizKey = outboundNo
    logParam.content = `调用3PL接口返回结果：${JSON.stringify(res)},耗时：${requestTime}`
    logParam.createUser = userInfo.userCode
    addLog(logParam);
  }catch (e){
    console.error("添加3pl请求日志异常，不影响业务，不做处理")
  }
}

/**
 * 通过后台接口获取打印能力
 * @param {*} obCheckQuery
 * @returns
 */
export const getAbilitiesFromMaster = async(obCheckQuery) => {
  console.log("通过后台接口获取打印能力入参为："+ JSON.stringify(obCheckQuery));
  let query = {};
  query.orgNo = obCheckQuery.orgNo;
  query.distributeNo = obCheckQuery.distributeNo;
  query.warehouseNo = obCheckQuery.warehouseNo;
  //货主编码
  query.bizKey = obCheckQuery.bizKey;
  let getAbilitiesResult = await shipmentService.getAbilities(query);

  // window.$abilities = [...getAbilitiesResult]

  return getAbilitiesResult
}
// 批量获取货主能力
export const getAbilitiesListFromMaster = async(obCheckQuery) => {
  console.log("通过后台接口获取打印能力入参为："+ JSON.stringify(obCheckQuery));
  let query = {};
  query.orgNo = obCheckQuery.orgNo;
  query.distributeNo = obCheckQuery.distributeNo;
  query.warehouseNo = obCheckQuery.warehouseNo;
  //货主编码
  query.bizKeys = obCheckQuery.bizKeys;
  let getAbilitiesListResult = await shipmentService.queryAbilityList(query);
  return getAbilitiesListResult
}

/**
 * 根据接口入参进行打印
 * @param {*} obCheckQuery
 * @param {*} printType
 * @returns
 */
export const print3PLAllGermanyHisensFace = async (obCheckQuery,printTypeArray) => {
  console.log("开始打印德国海信面单，调用3PL接口，入参为：" + JSON.stringify(obCheckQuery));
  let print3PLArray = [];
  if(printTypeArray != null && printTypeArray != ""){
    for(const  printFlag of printTypeArray){
      console.log("打印标识为：" + String(printFlag) + ",打印是否相等为：" + (String(printFlag) == "outbound_printSheet_printGoodsSheet") + ",第二种情况：" + (String(printFlag) === "outbound_printSheet_printGoodsSheet"));
      if (printFlag === 'outbound_noprintSheet') {
        console.log('不打印面单直接退出')
        // 不打印面单，直接退出
        return
      }
      if(printFlag == 'outbound_printSheet_printGoodsSheet'){
        print3PLArray.push(await print3PLGermanyHisenseFace(obCheckQuery,'outbound_printSheet_printGoodsSheet'));
      }else if(printFlag == 'outbound_printSheet_printShipSheet'){
        print3PLArray.push(await print3PLGermanyHisenseFace(obCheckQuery,'outbound_printSheet_printShipSheet'));
      }else if(printFlag == 'outbound_printSheet_printOutboundOrderSheet'){
        print3PLArray.push(await print3PLGermanyHisenseFace(obCheckQuery,'outbound_printSheet_printOutboundOrderSheet'));
      }
    }
    console.log('不打印面单直接退出，执行下面的方法没')
    await printPdfByCallBack(print3PLArray);
  }else{
    // $notify.error(i18n.t('callPrintPlatformFailureRemark'));
  }
}


/**
 * 打印德国海信面单接口封装
 * @param param 需要下传给3PL的参数
 * @param type  打单类型
 * @returns
 */
export const print3PLGermanyHisenseFace = async (param,printType) => {

console.log("从上游传递过来的入参为：" + JSON.stringify(param));

  //init 参数
  param.resDocFormat = "PDF";
  param.source = "WMS";

  let printRequestParam = null;

  if (printType === 7) {
    // 送货单 补打面单页面
    printRequestParam = await reprintDeliveryOrders(param);
  } else if (printType === 'outbound_printSheet_printShipSheet') {
    //送货单 复核打包一体化页面
    param.templateCode = "Hisense_Ship_List";
    let requiredDataResult = await queryDeliveryOrderInfo(param);
    console.log("从后台返回的参数777为：" + JSON.stringify(requiredDataResult));
    printRequestParam = requiredDataResult;//"20";
  }else if (printType === 6 || printType === 'outbound_printSheet_printGoodsSheet') {
    //货物面单
    param.templateCode = "Hisense_Commodity_Label";
    let requiredDataResult = await queryWaybillOrderInfo(param);
    console.log("从后台返回的参数666为：" + JSON.stringify(requiredDataResult));
    printRequestParam  = requiredDataResult;//"{\"totalWeight\":24.5,\"totalVolume\":175,\"totalPieces\":2,\"weightUnit\":\"KG\",\"dimensionUnit\":\"CM\",\"items\":[{\"materialNumber\":\"000000000020002829\",\"pieces\":1,\"weight\":14.5},{\"materialNumber\":\"000000000020002967\",\"pieces\":1,\"weight\":10.5}]}";

  }else if (printType === 8 || printType === 'outbound_printSheet_printOutboundOrderSheet') {
    //交接出库单
    param.templateCode = "Hisense_Delivery_Receipt";
    let requiredDataResult = await queryOutboundOrderInfo(param);
    console.log("从后台返回的参数888为：" + JSON.stringify(requiredDataResult));
    printRequestParam  = requiredDataResult;//"{\"warehouseName\":\"Warehouse ABC\",\"warehouseAddress\":\"Landrat Christians Str. 55\",\"warehousePostalCode\":\"28770\",\"warehouseProvince\":\"\",\"warehouseCity\":\"Bremen\",\"weightUnit\":\"KG\",\"dimensionUnit\":\"CM\",\"items\":[{\"materialNumber\":\"000000000020002829\",\"pieces\":1,\"weight\":50.00,\"volume\":50.00},{\"materialNumber\":\"000000000020002967\",\"pieces\":1,\"weight\":50.00,\"volume\":50.00}]}";
  }

  //开始调用3PL接口
  let startTime = new Date().getTime();
  console.log("德国海信打印单据，调用3PL接口请求参数:" + JSON.stringify(printRequestParam));
  let result = null;
  commonAddLog('paperlessPackageTag.js$print3PLGermanyHisenseFace().payload', printType, `德国海信打印单据，调用3PL接口入参：${JSON.stringify(printRequestParam)}`)
  try {
    // 面单补打 送货单 单独接口处理
    if (printType === 7) {
      result = await shipmentService.getBatchPrintPlatform(printRequestParam);
    } else {
      result = await shipmentService.getPrintPlatform(printRequestParam);
      // result = await requestTry(shipmentService.getPrintPlatform, 1, printRequestParam);
    }
  }catch(e){
    if(result != null){
      $notify.info(i18n.t('callPrintPlatformFailureRemark', [result.msg]));
    }
  }
  result.printType = printType
  let endTime = new Date().getTime();
  try {
    const logContent = _.cloneDeep(result);
    logContent.data.docResults = batchSubBase64(logContent.data.docResults);
    commonAddLog('paperlessPackageTag.js$print3PLGermanyHisenseFace().result', printType, `德国海信打印单据，调用3PL接口结果：${JSON.stringify(logContent)}`, {cost: endTime - startTime})
  } catch {
    commonAddLog('paperlessPackageTag.js$print3PLGermanyHisenseFace().result', printType, `德国海信打印单据，调用3PL接口结果：${JSON.stringify(result)}`, {cost: endTime - startTime})
  }
  console.log("德国海信打印单据，调用3pl接口耗时:" + (endTime - startTime) + "毫秒");

  return result;
  //开始打印
  //await printBy3PL(result);

}

// 获取交接单信息 （发票集 & IMO）
export const getBatchCodesInformation = async (params, printType) => {
  console.log("调用出库接口入参:", JSON.stringify(params))
  let ret
  try {
    // 1、请求出库后端接口（根据批次号获取订单信息）
    ret = await getPackageMDByBatchNo(params)
    console.log("调用出库接口返回值:", JSON.stringify(ret))
    // 如果批次下没有订单，页面提示
    if (ret === null || ret.length === 0) {
      $notify.warning(i18n.t('noOrderInBatch'))
      return;
    }

    // 2、构造请求参数，访问3PL接口
    const docId = params.batchNo.split(",")[0]
    const printParams = [12, 15].includes(printType)
      ? {
        templateCode: printType === 12 ? 'hkm_collective_invoice' : 'hkm_ch_collective_invoice',
        docId,
        orderId: params.batchNo,
        packageId: "",
        source: "WMS",
        resDocType: 1,
        resDocFormat: "XLS",
        requiredData: JSON.stringify(ret)
      }
      : {
        templateCode: "hkm_imo",
        docId,
        orderId: "",
        packageId: "",
        source: "WMS",
        resDocType: 1,
        resDocFormat: "PDF",
        // 数据量很大时，false表示返回一个多页的pdf
        isMultiPagePdf: false,
        requiredData: JSON.stringify(ret)
      };

    // 3、调用3PL接口
    console.log("调用3PL接口，请求参数：", JSON.stringify(printParams), printParams);
    let startTime = new Date().getTime();
    commonAddLog('paperlessPackageTag.js$getBatchCodesInformation().payload', docId, `调用3PL接口，请求入参：${JSON.stringify(printParams)}`)
    const printResult = await shipmentService.getPrintPlatform(printParams);
    // const printResult = await requestTry(shipmentService.getPrintPlatform, 1, printParams);
    let endTime = new Date().getTime();
    console.log("调用3PL接口，请求耗时：", (endTime - startTime) + "毫秒");
    console.log('调用3PL接口，返回结果:', printResult)
    try {
      const logContent = _.cloneDeep(printResult);
      logContent.data.docResults = batchSubBase64(logContent.data.docResults);
      commonAddLog('paperlessPackageTag.js$getBatchCodesInformation().result', docId, `调用3PL接口，请求结果：${JSON.stringify(logContent)}`, {cost: endTime - startTime})
    } catch {
      commonAddLog('paperlessPackageTag.js$getBatchCodesInformation().result', docId, `调用3PL接口，请求结果：${JSON.stringify(printResult)}`, {cost: endTime - startTime})
    }
    SgmPrintMonitor('call3plAPi_url_printPlatform', endTime - startTime, printResult)
    if (printResult.success === false) {
      $notify.error(printResult.msg)
    }

    // 4、请求成功，返回文件名
    if (printResult.data === null || printResult.data.docResults === null) {
      $notify.error(i18n.t('3plReturnNoData'))
    }
    return printResult.data.docResults[0];
  } catch (e) {
    console.error('获取交接单信息（发票集 & IMO）错误：', e)
  }
}

// 补打面单 —> 送货单
const reprintDeliveryOrders = async (param) => {
  return new Promise(async (resolve, reject) => {
    //送货单
    param.templateCode = "Hisense_Ship_List";
    let requiredDataResult = await batchQueryDeliveryOrderInfo(param);
    console.log("批量打印送货单 从后台返回：" + JSON.stringify(requiredDataResult));
    // todo 展示处理出错数据 提交正确数据
    // [{
    //   "amount": 2,
    //   "orderId": "WHQ1650012205",
    //   "docId": "WHQ1650012205",
    //   "source": "WMS",
    //   "templateCode": "Hisense_Ship_List",
    //   "requiredData": "{\"totalVolume\":\"0.0000000050030\",\"totalPieces\":8.0000,\"beforeRecheck\":false,\"totalWeight\":5.3000,\"dimensionUnit\":\"M3\",\"items\":[{\"pieces\":\"5.0000\",\"materialNumber\":\"test031801\",\"weight\":\"5.0000\"},{\"pieces\":\"3.0000\",\"materialNumber\":\"testwym02\",\"weight\":\"0.3000\"}],\"weightUnit\":\"g\"}",
    //   "resDocFormat": "PDF"
    // }]
    resolve(requiredDataResult)
  })
}

/**
 * 3PL打印通用封装
 * @param res 3PL返回的结果
 * @returns
 */
export const printPdfByCallBack = async (resultArray) => {
  console.log("当前回调执行的的返回参数为：" + "," + JSON.stringify(resultArray));
  if(!resultArray || !resultArray.length){
    console.log("触发终止执行逻辑");
    return;
  }
  if(resultArray) {
    let res = resultArray[0];
    console.log("打单平台获取面单结果为:"+JSON.stringify(res))
    if(res.code == 0 && res.data.docResults.length > 0){

      let imgUrl = res.data.docResults[0];
      let result = await convertBase64(imgUrl);
      //获取系统参数，是否开启PDF面单走云打印
      let pdfCloudPrintFlag = await getSysConfigByKey('enable_pdf_facesheet_cloud_print_hisens');
      console.log('仓是否开启海信pdf走云打印：' + pdfCloudPrintFlag + "（0：不开启；1：开启）")
      let imgType = judgeImgType(imgUrl)
      // 海信送货单 && pdf面单 && 系统参数开启, 走云打印
      if ((res.printType == '7' || res.printType == 'outbound_printSheet_printShipSheet') && 'pdf' == imgType && pdfCloudPrintFlag && pdfCloudPrintFlag == 1) {
        await cloudPrintPDF(result, imgUrl);
        console.log("第一个云打印完成，继续执行其他的");
        printPdfByCallBack(resultArray.slice(1))
      }else{
        printJS({printable: result.url, type: 'pdf', base64: true, onPrintDialogClose: () => printPdfByCallBack(resultArray.slice(1))});
      }
    }else{
      $notify.info(i18n.t('callPrintPlatformFailureRemark', [res.msg]));
      // 失败后继续打印剩余项
      printPdfByCallBack(resultArray.slice(1))
    }
  } else {
    $notify.info(i18n.t('1600112'));
    return null;
  }
}

//纯仓和印尼面单封装
export const printPureAndIndonesiaFaceLabel = async (obCheckM,orderInvoiceInfo,pkLabel,packageDetailed,otherInfo,warehouseInfo) => {
  let data = {}
  let content = {};
  if(obCheckM.commonFaceSheet == cloudPrintFaceLabelType.OVERSEAS_ORDER){
    content.templateId = 18
    content.templatePath = printConst.ABROAD_WAREHOUSE_ORDER_LABEL;
    content.printName = printConst.PRINT_ORDER;
    // 如果是换单，新增字段赋值 经与后端沟通不用判断 labelType === 1
    let orderAction = initOrderActions(obCheckM.wmsOrderMark)
    if (orderAction.isChangeBoxLabel) {
      data.labelReplace = '######  Label Replacement  ######';
    }
    data.customerName = orderInvoiceInfo.customerName;
    data.customerContacts = obCheckM.tel;
    data.customerOrderNo = obCheckM.channelsOutboundNo;
    data.orderNo = obCheckM.outboundNo;
    data.packageCode = pkLabel.packageNo;
    data.packageQty = `${pkLabel.packageOrder}/${pkLabel.packageQty}`;
    let packageWeight = Number.parseFloat(obCheckM.totalWeight).toFixed(2);
    data.packageWeight = `${packageWeight}  ${otherInfo.weightUnit}`;
    data.receivingAddress = otherInfo.strAddress;
    data.remark = otherInfo.strComment;
    data.warehouseNo = userInfo.warehouseNo;
    data.storeNo = obCheckM.storeNo;
    let goodsInfo= ''
    console.log("海外仓打印packageDetailed:" + JSON.stringify(packageDetailed));
    if(!_.isEmpty(packageDetailed)){
      for (let i = 0; i < packageDetailed.length; i++) {
        let packageD = packageDetailed[i];
        let goodsName = packageD.goodsName
        let goodsAliasCode = packageD.goodsAliasCode
        // 商品名称和客户sku编码最多展示15个字符
        if (packageD.goodsName && packageD.goodsName.length > 15) {
          goodsName = packageD.goodsName.substring(0,15) + "..."
        }
        if (packageD.goodsAliasCode && packageD.goodsAliasCode.length > 15) {
          goodsAliasCode = packageD.goodsAliasCode.substring(0,15) + "..."
        }
        if (packageD.outboundNo === obCheckM.outboundNo) {
          if(i<=2){
            // 某些商品没有客户sku编码
            if (packageD.goodsAliasCode) {
              goodsInfo = goodsInfo + `${goodsAliasCode}    ${goodsName}*${packageD.checkQty}\n`
            } else {
              goodsInfo = goodsInfo + `${packageD.goodsName}*${packageD.checkQty}\n`
            }
          }else{
            goodsInfo = `${goodsInfo}......`
            console.log("海外仓打印goodsInfo:\n" + goodsInfo)
            break;
          }
        }
      }
    }
    data.goodsInfo = goodsInfo;
  }
  if(obCheckM.commonFaceSheet == cloudPrintFaceLabelType.INDONESIA_ORDER){
    let tag = obCheckM.packageTag;
    content.templateId = 19;
    content.templatePath = printConst.INDONESIAN_ORDER_LABEL;
    content.printName = printConst.PRINT_ORDER;
    data.customerContacts = obCheckM.tel;
    data.customerName = orderInvoiceInfo.customerName;
    data.destinationCode = obCheckM.siteNo;
    data.destinationCrossCode = (tag == null) ? "" : tag.targetCrossCode;
    data.destinationDistributSite =`${obCheckM.siteNo},`+ obCheckM.siteName;
    data.destinationName = (tag == null) ? "" : tag.targetDistriName;
    data.destinationTabletrolleyCode = (tag == null) ? "" : tag.targetTabletrolleyCode;
    data.ECLPNO = `${obCheckM.outboundNo},${obCheckM.channelsOutboundNo}`
    data.orderCode = obCheckM.channelsOutboundNo;
    data.originalCode = obCheckM.warehouseNo;
    data.originalCrossCode = (tag == null) ? "" : tag.startCrossCode;
    data.originalName = (tag == null) ? "" : tag.startDistributeName;
    data.originalTabletrolleyCode = (tag == null) ? "" : tag.startTabletrolleyCode;
    data.ownerType = obCheckM.revenueClientType;
    data.packageCode = pkLabel.packageNo;
    data.packageIndex = `${pkLabel.packageOrder}/${pkLabel.packageQty}`
    data.packageTime = i18n.t(checkConstant.packText, [formatDateTime(new Date()), pkLabel.platformNo]);
    let packageWeight = Number.parseFloat(obCheckM.totalWeight).toFixed(2);
    data.packageWeight = `${packageWeight}  ${otherInfo.weightUnit}`;
    data.paymentText = otherInfo.paymentText;
    data.printAddress = otherInfo.strAddress;
    data.road = obCheckM.areaCode;
    data.storeName = obCheckM.storeName;
    data.waveInfo = otherInfo.strTimeCategory;
    data.waybillCode = otherInfo.barCode;
  }

  content.data = data;
  console.log("进入打单改造新面单逻辑 content:" + JSON.stringify(content));
  return content;
}

/**
 * 执行shipping paper单据打印，采用云打印
 *
*/
export const executeShippingPaperPrint = async (labelUrl) => {
  console.log("executeShippingPaperPrint转换base64：" + labelUrl)
  try{
    let imgType = judgeImgType(labelUrl)
    if ('png' == imgType || 'PNG' == imgType) {
      //png的话 走云打印
      if(labelUrl){
        // 采用云打印打印面单
        let content = {}
        content.templateId = 42 //ups_shippint_paper
        let data = {}
        content.data = data
        data.picture = labelUrl
        await print(content)
      }
    } else if(imgType == 'pdf' || imgType == 'PDF') {
      // 转base64
      // https://storage.jd.com/doccenter/2023-09-11/gtc_doc_center_babylist_tok_mark_1_70a569faa5844c00ad374b253e591a45.PDF?Expires=1725951747&AccessKey=RMYyBREPKrpSYYv5&Signature=VHzjRS%2BnHwqVmn4C04TTmCzhbBQ%3D
      console.log("executeShippingPaperPrint转换base64：" + labelUrl)
      let timeConSta = new Date().getTime();
      let result = await convertBase64(labelUrl)
      if(result && result.url){
        let base64Code = result.url
        let timeConEnd = new Date().getTime();
        console.log("Base64转换耗时：" + (timeConEnd - timeConSta));
        // 组装参数
        let content = {}
        //ups_shippint_paper
        content.templateId = 42
        content.printPDF = 1
        content.pdfSrc = base64Code
        let data = {}
        content.data = data
        data.picture = labelUrl
        console.log('content',content)
        // 云打印
        await print(content)
      }
      console.log("转换base64：" + result)
    } else{
      //非PNG\PDF格式打印报错
      console.log("基于图片类型调用云打印失败：" + labelUrl)
    }
  }catch (e) {
    console.log("基于图片类型调用云打印失败error：",e)
  }
}

/**
 * 发票走云打印
 *
 */
export const executeInvoicePrint = async (labelUrl) => {
  console.log("发票走云打印，url：" + labelUrl)
  try {
    let imgType = judgeImgType(labelUrl)
    let content = {
      templateId: 10,
      data: {
        picture: labelUrl
      }
    }
    if ('png' == imgType || 'PNG' == imgType) {
      console.log("发票走云打印，单据格式png，走云打印")
      await print(content)
    } else if (imgType == 'pdf' || imgType == 'PDF') {
      console.log("发票走云打印，单据格式pdf，走云打印，转base64")
      let startTime = new Date().getTime();
      let result = await convertBase64(labelUrl)
      if (result && result.url) {
        let base64Code = result.url
        console.log("Base64转换耗时：" + (new Date().getTime() - startTime));
        // 组装参数
        content = { ...content,
          printPDF: 1,
          pdfSrc: base64Code
        }
        // 云打印
        await print(content)
      }
    } else {
      console.log("发票走云打印，发票单据类型非PNG/PDF，无法打印：" + labelUrl)
    }
  } catch (e) {
    console.log("发票走云打印，打印异常：", e)
  }
}



// 单包裹第一次校验是否执行ShippingPaper面单
export const checkShippingPaperPrint = async (labelInfos) => {
  let flag = false
  for (let returnLabel of labelInfos) {
    // console.info("returnLabel:" + JSON.stringify(returnLabel))
    if(returnLabel !== undefined && returnLabel.labelType !== null && returnLabel.labelType === shipmentLabelType.shipping_paper){
      flag = true
      console.info("checkShippingPaperPrint 需要打印ShippingPaper单类型");
    }
  }
  return flag
}

// 单包裹第一次校验是否执行invoice打印
export const checkInvoicePrint = async (labelInfos) => {
  let flag = false
  for (let returnLabel of labelInfos) {
    // console.info("returnLabel:" + JSON.stringify(returnLabel))
    if(returnLabel !== undefined && returnLabel.labelType !== null && returnLabel.labelType === shipmentLabelType.package_invoice){
      flag = true
      console.info("checkInvoicePrint 需要打印包裹维度发票");
    }
  }
  return flag
}
// 补打校验是否执行ShippingPaper面单
// onlyPrintlabelKind 默认允许为空或者undefined
export const shippingPaperRepeatPrint = async (result, obCheckM) => {
  console.info("isRepairPrint:" + obCheckM.isRepairPrint +
  " pageType: " + obCheckM.pageType +
  " onlyPrintlabelKind: " + obCheckM.onlyPrintlabelKind)
  console.info("shippingPaperRepeatPrint result:" + JSON.stringify(result))
  let flag = false // 返回是否不再调用浏览器打印，默认调用

  // 优先判断是单独补打页面还是其他打单页面
  if(obCheckM.pageType !== undefined && obCheckM.pageType !== null &&
    obCheckM.pageType === 'ups_shipping_paper'){
    // 如果补打页面只打印SHIPPING_PAPER，则所有返回都不再调用浏览器打印
    if(obCheckM.onlyPrintlabelKind !== undefined && obCheckM.onlyPrintlabelKind !== null &&
      obCheckM.onlyPrintlabelKind === labelKindFor3pl.SHIPPING_PAPER){
        flag = true
        if(result.labelKind !== undefined && result.labelKind !== null && result.labelKind === labelKindFor3pl.SHIPPING_PAPER){
          console.log('调用云打印 重打印SHIPPING_PAPER url：' + result.images[0]);
          await executeShippingPaperPrint(result.images[0])
        }
    }else{
      // 打印正逆向面单，则不打印重打印SHIPPING_PAPER，过滤掉
      if(result.labelKind !== undefined && result.labelKind !== null && result.labelKind === labelKindFor3pl.SHIPPING_PAPER){
        flag = true
      }
    }
  }else{
    // 重打包则打印，补打面单不打印SHIPPING_PAPER
    if(result.labelKind !== undefined && result.labelKind !== null && result.labelKind === labelKindFor3pl.SHIPPING_PAPER){
      // 调用云打印
      flag = true
      console.log('调用云打印 打印SHIPPING_PAPER url：' + result.images[0]);
      await executeShippingPaperPrint(result.images[0])
    }
  }
  console.info("不再调用浏览器打印面单:" + flag)
  return flag
}


// 执行ShippingPaper打印面单
export const doShippingPaperPrint = async (labelInfos,obCheckM) => {
  let labelInfo = null
  for (let lb of labelInfos) {
    if(lb.labelType === shipmentLabelType.shipping_paper){
      console.log('shipping paper 单：' + lb.faceOrderAddress);
      try {
        // 调用云打印 打印 ShippingPaper 单据
        await executeShippingPaperPrint(lb.faceOrderAddress);
      } catch (e) {
        console.error("打印 shipping paper 单发生异常：" + e)
      }
    }else if(lb.labelType === shipmentLabelType.forward_label){
      // 返回要打印的正向面单
      labelInfo = lb
    }
  }
  console.info("执行ShippingPaper后 需要打印的面单："  + JSON.stringify(labelInfo))
  return labelInfo
}

export const doInvoicePrint = async (labelInfos,obCheckM) => {
  let labelInfo = null
  for (let lb of labelInfos) {
    if(lb.labelType === shipmentLabelType.package_invoice){
      console.log('发票url：' + lb.faceOrderAddress);
      try {
        // 调用云打印 打印 发票
        await executeInvoicePrint(lb.faceOrderAddress);
      } catch (e) {
        console.error("打印发票发生异常：" + e)
      }
    }else if(lb.labelType === shipmentLabelType.forward_label){
      // 返回要打印的正向面单
      labelInfo = lb
    }
  }
  console.info("执行发票后需要打印的面单："  + JSON.stringify(labelInfo))
  return labelInfo
}

// 根据单号或者包裹号查询马士基发票信息
export const printMsjInvoice = async (params,printNum = 1) => {
  console.info("Print MSJ Invoice start" + JSON.stringify(params));
  let obCheckM = params.checkM
  // 打印马士基发票
  let sukList = []
  params.listCheckR.forEach(item => {
    console.info("item:" + JSON.stringify(item));
    sukList.push(
      {
        skuName : item.goodsName,
        num : item.checkQty,
        skuCode : item.goodsNo,
        barCode : item.scanCode
      }
    )
  })

  let checkQuery = {
    orgNo : userInfo.orgNo,
    distributeNo : userInfo.distributeNo,
    warehouseNo : userInfo.warehouseNo,
    listOutboundNo : [obCheckM.outboundNo]
  }
  let resultMap = await shipmentService.queryPrintOrderLists(checkQuery);
  console.info("resultMap:" + JSON.stringify(resultMap));
  if (_.isEmpty(resultMap)) {
    $notify.error(this.$t('打印马士基发票获取订单详情为空！'));
    return;
  }
  let shipmentExt = resultMap[0]
  console.info("shipmentExt:" + JSON.stringify(shipmentExt));

  // 查询仓名称
  let param = {
    warehouseNo: userInfo.warehouseNo,
    orgNo: userInfo.orgNo,
    distributeNo: userInfo.distributeNo
  }
  let warehouse = await getWarehouse(param)

  let printParam = {
    labelType : LabelType.MSJ_INVOICE_LABEL,//马士基发票
    docId : obCheckM.outboundNo,
    orderId : obCheckM.outboundNo,
    msjInvoice : {
      country : shipmentExt.country,
      warehouseInfo : warehouse.warehouseName,
      address : obCheckM.sendAddress,
      consignee : shipmentExt.contacts,
      customerBillCode : obCheckM.outboundNo,
      invoiceNumber : shipmentExt.fieldMap.invoiceNumber,
      deliveryDate : obCheckM.createTime,
      sukList : sukList,
      zipcode_city : obCheckM.zipCode + ' ' + shipmentExt.city
    }
  }
  console.info("printParam : " + JSON.stringify(printParam));
  await callPrintPlatform(printParam,printNum)
  console.info("Print MSJ Invoice finished");
}

// 校验是否执行逆向打印正逆向面单
export const checkReversePrint = async (labelInfos) => {
  let flag = false
  for (let returnLabel of labelInfos) {
    // console.info("returnLabel:" + JSON.stringify(returnLabel))
    if(returnLabel !== undefined && returnLabel.labelType !== null && returnLabel.labelType === shipmentLabelType.order_reverse_label){
      flag = true
      console.info("checkReversePrint 需要打印逆向运单类型");
    }
  }
  return flag
}

// 校验是否执行3PL逆向打印正逆向面单
export const check3PLReversePrint = async (resultList, obCheckM) => {
  console.info("check3PLReversePrint resultList:" + JSON.stringify(resultList))
  let flag = false
  if(_.isEmpty(resultList.labels)){
    return flag
  }
  for (let label of resultList.labels) {
    console.info("label:" + JSON.stringify(label))
    if(label !== undefined && label.labelKind !== null && label.labelKind === labelKindFor3pl.RETURNED){
      flag = true
      console.info("check3PLReversePrint 需要保存逆向运单号");
    }
  }
  return flag
}

// 执行打印正逆向面单
export const doReversePrint = async (labelInfos,obCheckM) => {
  console.info("doReversePrint obCheckMR:" + JSON.stringify(obCheckM))
  // 待返回的整箱面单数据
  let labelInfo = null

  for (let lb of labelInfos) {
    // console.info("doReversePrint lb:" + JSON.stringify(lb))
    // 赋值正向单号,这里取值checkM下的数据，因为label存的正向面单号为DT单号
    // 正向面单和zpl都赋值
    if(lb.labelType === shipmentLabelType.forward_label || lb.labelType === shipmentLabelType.zpl){
      // 返回要打印的正向面单
      labelInfo = lb
      console.log('正向面单：' + lb.faceOrderAddress);
    }
    // 赋值逆向单号，由后面setPackageTrackingNo接口进行保存
    // 仓里默认是需要打印逆向面单，fop通过下标识控制不打印
    if(lb.labelType === shipmentLabelType.order_reverse_label){
      obCheckM.reverseShipNo = lb.newShipNo
      if (obCheckM && obCheckM.printReverseFlag && obCheckM.printReverseFlag === 1) {
        console.info("订单号：" + obCheckM.outboundNo + ", fop打标不打印逆向面单");
        continue
      }
      try {
        // 打印逆向面单
        await executeECLPExternalOrderPackageTagPrint(obCheckM, lb.face,lb.faceOrderAddress,false);
      } catch (e) {
        console.error("调用青龙接口获取并打印3PL面单发生异常：" + e)
      }
      console.log('逆向面单：' + lb.faceOrderAddress);
    }
  }
  // 返回正向面单
  return labelInfo
}

//
export const initReversePackageM = async (resultList,obCheckMR) => {
  console.log("initReversePackageM obPackageM:" + JSON.stringify(obCheckMR))
  let packageList = obCheckMR.listPackageM
  for (let label of resultList.labels) {
    console.info("label:" + JSON.stringify(label))
    for(let packageM of packageList){
      if(label.packageID === packageM.packageNo){
        if(label !== undefined && label.labelKind !== null && label.labelKind === labelKindFor3pl.FORWARD){
          packageM.checkShipNo = label.trackingNumber
        }
        if(label !== undefined && label.labelKind !== null && label.labelKind === labelKindFor3pl.RETURNED){
          packageM.reverseShipNo = label.trackingNumber
        }
      }
    }
  }
  // 去重
  console.info("去重前 packageList:" + JSON.stringify(packageList))
  const packageNoMap = new Map()
  let listPackageRepeat = packageList.filter((a) => !packageNoMap.has(a.packageNo) && packageNoMap.set(a.packageNo, 1))
  console.info("去重后 listPackageRepeat:" + JSON.stringify(listPackageRepeat))
  obCheckMR.listPackageM = listPackageRepeat
}

// 针对MCA新面单 处理电话号码
export const dealTel = (obCheckM, content) => {
  console.info('MCA新面单处理电话号码:' + obCheckM.tel)
  // 处理电话号码 checkM.tel的数据格式：'telephone,mobile' 示例：'123123,111222' 或 ',111222' 或 '123123,' 或 ','
  if (!_.isEmpty(obCheckM.tel)) {
    let tels = obCheckM.tel.split(',')
    let realTel = ''
    if (tels.length === 1) {
      // 说明tel只有一个电话号码 则只处理这一个即可
      realTel = tels[0]
    } else if (tels.length === 2) {
      // 说明tel是有,分割的字符串 需要看哪个是正确的电话号码，如果两个都是电话则处理第一个
      if (!_.isEmpty(tels[0])) {
        realTel = tels[0]
      } else if (!_.isEmpty(tels[1])) {
        realTel = tels[1]
      }
    }
    if (!_.isEmpty(realTel)) {
      // 61****188，加*号逻辑为“从后往前数，第1-3位显示，第4-7位以****替代，第8位开始全部显示
      if (realTel.length >= 8) {
        realTel = realTel.substring(0, realTel.length - 7) + '****' + realTel.substring(realTel.length - 3, realTel.length)
        content.data.customerContacts = realTel
      }
    }
  }
}

// 针对MCA新面单 处理温层标识
export const dealTemp = (obCheckM, content) => {
  if (obCheckM.warmLayerFlag === 'F' || obCheckM.warmLayerFlag === 'HF') {
    content.data.warmLayerFlag = '❄'
  } else {
    content.data.warmLayerFlag = obCheckM.warmLayerFlag
  }
}

/**
 * 纯仓打印收件人信息
 * @param printNum 打印份数
 * */
 export const printRecipientInformation = async (printModel,printNum = 1) => {
  if (printModel.labelType && (printModel.labelType == 1 || printModel.labelType == 2)) {
    console.log("纯仓打印收件人信息", JSON.stringify(printModel))
    try{
        // 采用云打印
        let content = {}
        content.templateId = 27 //定制模板
        let data = {
          contacter: printModel.contacter,
          address: printModel.address,
          tel: printModel.tel,
          zipCode: printModel.zipCode
        }
        content.data = data
        await print(content,printNum)
        commonAddLog('PaperlessPackageTag.js$printRecipientInformation()',printModel.outboundNo,`复核---纯仓打印收件信息`)
    }catch (e) {
      console.log("调用云打印失败error：",e)
    }
  }
 }

/**
 * 执行打印call单失败的替换页
 * @param printNum 打印份数
 * */
export const printCallLabelFailedReplaceTab = async (info) => {
  //获取系统参数，是否开启call单失败打印占位面单
  let openFlag = await getSysConfigByKey('print_call_label_failed_replace_tab');
  console.log('开启call单失败打印占位面单系统参数配置值为：' + openFlag + "（0：不开启；1：开启）")
  //优先看系统参数配置，当系统参数未开启时，再看流程管理配置中货主是否开启outbound_printSheet_error_replace
  if(!openFlag || openFlag != 1){
    if(!info.ownerNo) {
      console.log('ownerNo为空')
      return
    }
    let queryFromMaster = {
      orgNo: userInfo.orgNo,
      distributeNo: userInfo.distributeNo,
      warehouseNo: userInfo.warehouseNo,
      bizKey: info.ownerNo
    };
    let printTypeArray = await getAbilitiesFromMaster(queryFromMaster)
    let openFlagByOwner = printTypeArray && printTypeArray.indexOf('outbound_printSheet_error_replace') > -1
    console.log('开启call单失败打印占位面单流程管理配置值为：' + openFlagByOwner)
    openFlag = openFlagByOwner ? 1 : ''
  }

  if (openFlag !== null && openFlag !== undefined && openFlag !== '' && openFlag && openFlag == 1) {
    console.log('call单失败占位模板-云打印')
    console.log("call单失败call3plResult:" + JSON.stringify(info))
    try {
      // 采用云打印
      let content = {}
      content.templateId = 34 //call单失败占位面单
      let data = {
        failedReason: info ? info.errorMassage : '',
        outboundNo: info.outboundNo,
        packageNo: info.packageNo
      }
      content.data = data
      await print(content, 1)
      commonAddLog('PaperlessPackageTag.js$printCallLabelFailedReplaceTab()', info.outboundNo, `call单失败-打印占位标签`)
    } catch (e) {
      console.log("调用云打印失败-call单失败占位面单打印:", e)
    }
  } else {
    console.log("未开启call单失败打印占位面单系统参数，不做任何处理")
  }
}
/**
 * 保存失败的call单结果
 * @param packageList
 * @param obCheckM
 * @param callFailDesc
 * */
export const saveCallFailResult = async (packageList,obCheckM,callFailDesc) => {
  try {
    let obCheckMR = {}
    let listPackageM= []
    for(let obPackage of packageList){
      let newPackage = {}
      newPackage.batchNo = obCheckM.batchNo
      newPackage.outboundNo = obCheckM.outboundNo
      if (callFailDesc && callFailDesc.length > 256) {
        callFailDesc = callFailDesc.substring(0, 200)
      }
      newPackage.callFailDesc = callFailDesc
      newPackage.orgNo = obCheckM.orgNo
      newPackage.distributeNo = obCheckM.distributeNo
      newPackage.warehouseNo = obCheckM.warehouseNo
      newPackage.packageNo = obPackage.packageNo
      listPackageM.push(newPackage)
    }
    obCheckMR.listPackageM = listPackageM
    console.log('保存失败的call单结果',obCheckMR)
    await shipmentService.savePackageTagFor3PL(obCheckMR)
  } catch (e) {
    console.log("保存失败的call单结果异常:", e)
  }
}

// 第一个包裹打标
export const markFirstPackageFlag = (sourcePackages) => {
  let packages = sourcePackages && sourcePackages.length > 0 ? [...sourcePackages] : []
  if (packages && packages.length > 0) {
    let idxByMiniPakcageNo = -1; let miniPakcageNo = 1
    packages.forEach((item, idx) => {
      const itemPackageNo = item.packageID.split('-')[1]
      if (itemPackageNo <= miniPakcageNo) {
        miniPakcageNo = itemPackageNo
        idxByMiniPakcageNo = idx
      }
    })
    if (idxByMiniPakcageNo > -1) {
      packages[idxByMiniPakcageNo].firstPackage = true
    }
  }
  return packages
}

// 系统参数开关 JDW单号改造  JDW_ORDER_REMOULD
export const isJDWNoRemouldSys = async(printParam) => {
  console.log("🚀 ~ isJDWNoRemouldSys ~ printParam:", printParam.jdwNewFaceFlag)
  if (!printParam) return false
  return printParam.jdwNewFaceFlag
}

export const JDWNoRemouldParams = (model, printParam) => {
  let modelNew = {
    orderNo: model.orderId,
    jdwWaybillCode: printParam.jdwWaybillCode,
    thrOrderNo: model.thrOrderId,
    orderSource: model.source,
    baseParams: {
      returnShipment: model.returnShipment,
      operationOrder: model.optionType,
      expressCompId: model.expressCompId,
      labelFileType: model.imageType,
      returnLabelType: model.labelRetType,
      sourceNodeCode: model.sourceNodeCode,
      siteFlag: model.siteFlag,
      salePlat: printParam.orderLocal
    },
    packageParam: markFirstPackageFlag(model.packages),
    extendsParam: {
      lastOfBatch: model.lastOfBatch,
      labelStockType: model.labelStockType,
      weightUnits: model.weightUnits,
      dimensionsUnits: model.dimensionsUnits,
      weight: model.weight,
      packageDimension: model.packageDimension, // 打包维度：0-订单维度(不传默认是)，1-包裹维度(针对拆单订单)
      forceSinglePackage: model.forceSinglePackage, // 强制一单一包裹生产（fop下单的orderMark在56位，一单一包裹生产，0否1是）
    }
  }
  if(model.receiver){
    modelNew.receiverParam = model.receiver
  }
  if(model.sender){
    modelNew.senderParam = model.sender
  }
  if(model.outboundNo) {
    modelNew.outboundNo = model.outboundNo
  }
  return modelNew
}

export const matchWaybillNo = (packageId, waybillNoList) => {
  let waybillNo = null
  if (waybillNoList && waybillNoList.length > 0) {
    waybillNoList.some(item => {
      if (item.packageId === packageId) {
        waybillNo = item.waybillNo
        return true
      }
    })
  }
  return waybillNo
}

export const matchReverseWaybillNo = (packageId, waybillNoList) => {
  let reverseWaybillNo = null
  if (waybillNoList && waybillNoList.length > 0) {
    waybillNoList.some(item => {
      if (item.packageId === packageId) {
        reverseWaybillNo = item.reverseWaybillNo
        return true
      }
    })
  }
  return reverseWaybillNo
}

/**
 * 云打印打印Base64
 * @param printNum 打印份数
 * */
export const qrCodePrint = async (labelUrl, info = {}, templateId = 71) => {
  console.log("已开启PDF面单走云打印,开始组装模板参数...");
  // 组装参数
  let content = {}
  content.templateId = templateId
  //content.printPDF = 1
  // content.pdfSrc = labelUrl
  let data = {...info}
  content.data = data
  data.picture = labelUrl
  console.log("PNG文件云打印参数组装完成，开始执行打印,content:" + JSON.stringify(content))
  // 云打印
  await print(content)
}

// 通用云打印方法
export const commCloudPrint = async(data, templateId) => {
  if (!templateId) {
    return
  }
  // 组装参数
  let content = {
    templateId,
    data
  }
  // 云打印
  await print(content)
}